const defaultFrenchMessages = {
  date: {
    defaultDateFormat: "dd.MM.yyyy",
    defaultDateTimeFormat: "dd.MM.yyyy kk:mm:ss",
    dateInputPattern: "##.##.####",
  },
  ra: {
    action: {
      add_filter: "Ajouter un filtre",
      add_price_position: "Ajouter une position",
      add: "Ajouter",
      accept: "Accepter",
      back: "Retour",
      bulk_actions: "Un élément sélectionné |||| %{smart_count} éléments sélectionnés",
      cancel: "Annuler",
      clear_input_value: "Effacer l'entrée",
      clear_array_input: "Effacer la liste",
      clone: "Cloner",
      close: "Fermer",
      close_menu: "Fermer le menu",
      confirm: "Confirmer",
      create: "Créer",
      create_item: "Créer une entrée",
      delete: "Supprimer",
      download: "Télécharger",
      edit: "Éditer",
      expand: "Développer",
      export: "Exporter",
      list: "Liste",
      move_down: "Descendre",
      move_up: "Monter",
      open: "Ouvrir",
      open_menu: "Ouvrir le menu",
      reset: "Reset",
      refresh: "Rafraîchir",
      remove_filter: "Retirer le filtre",
      remove_all_filters: "Retirer tous les filtres",
      remove: "Retirer",
      save: "Enregistrer",
      search: "Rechercher",
      search_columns: "Rechercher dans les colonnes",
      select_all: "Tout sélectionner",
      select_all_button: "Tout sélectionner",
      select_row: "Sélectionner une entrée",
      select_columns: "Colonnes",
      send: "Envoyer",
      show: "Afficher",
      sort: "Trier",
      toggle_theme: "Changer de thème",
      undo: "Annuler",
      unselect: "Désélectionner",
      update: "Mettre à jour",
      update_application: "Mettre à jour l'application",
    },
    boolean: {
      true: "Oui",
      false: "Non",
      null: " ",
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "Créer %{name}",
      loading: "Chargement",
      dashboard: "Tableau de bord",
      not_found: "Non trouvé",
      error: "Quelque chose a mal tourné",
      empty: "Rien n'est encore disponible.",
      invite: "Voulez-vous changer quelque chose?",
      access_denied: "Accès refusé",
      authentication_error: "Erreur d'authentification",
    },
    sort: {
      ASC: "croissant",
      DESC: "décroissant",
      sort_by: "%{field}",
    },
    input: {
      file: {
        upload_several: "Glissez les fichiers à télécharger ou cliquez ici pour sélectionner des fichiers.",
        upload_single: "Glissez le fichier à télécharger ou cliquez ici pour sélectionner un fichier.",
      },
      image: {
        upload_several: "Glissez les images à télécharger ou cliquez ici pour sélectionner des images.",
        upload_single: "Glissez l'image à télécharger ou cliquez ici pour sélectionner une image.",
      },
      password: {
        toggle_visible: "Masquer le mot de passe",
        toggle_hidden: "Afficher le mot de passe",
      },
      references: {
        all_missing: "Les références associées n'ont pas pu être trouvées.",
        many_missing: "Au moins une des références associées semble ne plus être disponible.",
        single_missing: "Une référence associée semble ne plus être disponible.",
      },
    },
    message: {
      yes: "Oui",
      no: "Non",
      are_you_sure: "Es-tu sûr?",
      about: "À propos",
      auth_error: "Veuillez vous connecter pour continuer",
      not_found: "La page est introuvable.",
      loading: "La page est en cours de chargement.",
      invalid_form: "Le formulaire est invalide. Veuillez vérifier vos entrées.",
      delete_title: "Supprimer",
      delete_content: "Voulez-vous vraiment supprimer ce contenu?",
      bulk_delete_title: "Confirmer la suppression",
      bulk_delete_content:
        "Voulez-vous vraiment supprimer cet élément? |||| Voulez-vous vraiment supprimer ces %{smart_count} éléments?",
      bulk_update_content:
        "Voulez-vous vraiment mettre à jour cet élément? |||| Voulez-vous vraiment mettre à jour ces %{smart_count} éléments?",
      bulk_update_title: "Confirmer la mise à jour",
      clear_array_input: "Voulez-vous vraiment supprimer toute la liste?",
      details: "Détails",
      error: "Une erreur s'est produite et votre demande n'a pas pu être complétée.",
      unsaved_changes: "Certaines modifications n'ont pas été enregistrées. Voulez-vous vraiment ignorer?",
      delete_failed_must_archive: "La suppression est impossible, veuillez archiver.",
      access_denied: "Accès refusé",
      authentication_error: "Erreur d'authentification",
      select_all_limit_reached: "Nombre maximal de sélection atteint",
      placeholder_data_warning: "Problème réseau : échec de l'actualisation des données.",
    },
    navigation: {
      no_results: "Pas encore disponible",
      no_more_results: "La page %{page} ne contient aucun contenu.",
      page_out_of_boundaries: "La page %{page} est hors des limites valides",
      page_out_from_end: "Dernière page",
      page_out_from_begin: "Première page",
      page_range_info: "%{offsetBegin}-%{offsetEnd} sur %{total}",
      page_rows_per_page: "Lignes par page :",
      next: "Suivant",
      prev: "Retour",
      previous: "Retour",
      skip_nav: "Aller au contenu",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} sur plus de %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Page %{page}",
      first: "Première page",
      last: "Dernière page",
      no_filtered_results: "Aucun résultat trouvé pour ces filtres.",
      clear_filters: "Réinitialiser tous les filtres",
    },
    auth: {
      auth_check_error: "Veuillez vous connecter pour continuer",
      user_menu: "Profil",
      username: "E-mail",
      email: "E-Mail",
      password: "Mot de passe",
      sign_in: "Se connecter",
      sign_in_error: "Erreur de connexion",
      logout: "Se déconnecter",
    },
    notification: {
      i18n_error: "Traductions non disponibles pour la langue sélectionnée.",
      not_authorized: "Vous n'avez pas accès à ce contenu.",
      updated: "Élément mis à jour |||| %{smart_count} éléments mis à jour",
      created: "Élément créé",
      deleted: "Élément supprimé |||| %{smart_count} éléments supprimés",
      bad_item: "Élément défectueux",
      item_doesnt_exist: "L'élément n'existe pas",
      http_error: "Erreur de communication avec le serveur",
      data_provider_error: "Erreur dataProvider. Vérifiez la console pour plus de détails.",
      canceled: "Action annulée",
      logged_out: "Vous avez été déconnecté. Veuillez vous reconnecter.",
      application_update_available: "Mise à jour disponible",
      offline: "Offline",
    },
    validation: {
      required: "Requis",
      minLength: "Doit contenir au moins %{min} caractères",
      maxLength: "Ne doit pas dépasser %{max} caractères",
      minValue: "Doit être au moins %{min}",
      maxValue: "Doit être %{max} ou moins",
      number: "Doit être un nombre",
      email: "Doit être un e-mail valide",
      oneOf: "Doit être l'un des suivants : %{options}",
      regex: "Doit correspondre à l'expression régulière suivante : %{pattern}",
      not_unique: "est déjà utilisé",
      unique: "Doit être unique",
    },
    saved_queries: {
      label: "Filtres enregistrés",
      query_name: "Nom du filtre",
      new_label: "Enregistrer le filtre actuel...",
      new_dialog_title: "Enregistrer le filtre actuel sous",
      remove_label: "Supprimer le filtre enregistré",
      remove_label_with_name: 'Supprimer le filtre enregistré "%{name}"',
      remove_dialog_title: "Supprimer le filtre enregistré ?",
      remove_message: "Voulez-vous vraiment supprimer cet élément de votre liste de filtres enregistrés ?",
      help: "Filtrer la liste et enregistrer le paramètre de filtre",
    },
    configurable: {
      customize: "Personnaliser",
      templateError: "## Erreur de modèle",
      configureMode: "Configurer cette page",
      inspector: {
        title: "Inspecteur",
        content: "Pointez sur les éléments de l'application pour les personnaliser",
        reset: "Réinitialiser les paramètres",
        hideAll: "Tout cacher",
        showAll: "Tout afficher",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Texte principal",
        secondaryText: "Texte secondaire",
        tertiaryText: "Texte tertiaire",
      },
      Datagrid: {
        title: "Tableau de données",
        unlabeled: "Colonne non étiquetée #%{column}",
      },
      SimpleForm: {
        title: "Formulaire",
        unlabeled: "Champ non étiqueté #%{input}",
      },
    },
  },
};
const userFields = {
  id: "ID",
  image_path: "Chemin de l'image",
  lecturer_fee: "Rémunération",
  user_custom_fields_data: "Champs avancés",
  is_unverified: "Non vérifié",
  guest: "Invité",
  title: "Titre",
  first_name: "Prénom",
  last_name: "Nom de famille",
  full_name: "Nom",
  gender: "Sexe",
  birthday: "Date de naissance",
  address: "Adresse",
  main_contact_info: "Communication",
  invoice_contact_info: "Facturation",
  invoice_dispatch_contact_info: "Expédition de facture",
  main_contact_info__email: "E-mail (Communication)",
  main_contact_info__organization_name: "Nom de l'organisation (Communication)",
  main_contact_info__city: "Ville (Communication)",
  main_contact_info__postcode: "Code postal (Communication)",
  login_email: "E-mail de connexion",
  auth_user__email: "E-mail de connexion",
  lecturer__common_fee: "Rémunération (€)",
  attendee__attendee_number: "Numéro de client",
  contact_types: "Type d'information de contact",
  debit_number: "Numéro de débiteur",
  audience_role: "Public cible",
  common_fee: "Rémunération (€)",
  description: "Description",
  qualifications: "Qualifications",
  categories: "Catégories",
  image: "Image",
  documents: "Documents",
  created_at: "Créé",
  contact_info: {
    id: "ID",
    email: "E-mail",
    phone: "Téléphone",
    mobile: "Portable",
    fax: "Fax",
    website: "Site web",
    organization_name: "Nom de l'organisation",
    address_line_1: "Ligne d'adresse 1",
    address_line_2: "Ligne d'adresse 2",
    co: "c/o",
    postcode: "Code postal",
    countrycode: "Indicatif du pays",
    city: "Ville",
    state: "État",
    country: "Pays",
  },
  tags: "Étiquettes",
  language: "Langue",
  lists: "Listes abonnées",
  accounts: "Comptes",
  organization_names: "Organisations assignées",
};
const userAndEnrollmentFilters = {
  contact_organization_names: "Nom d'organisation (coordonnées)",
  emails: "E-mails",
  qualifications: "Qualifications",
  categories: "Catégories",
  event_base_categories: "Catégories d'offres",
};
const customFieldContentTypeName = "Champ avancé |||| Champs avancés";
const frenchMessages = {
  ...defaultFrenchMessages,
  resources: {
    applications: {
      name: "Application OAuth |||| Applications OAuth",
    },
    event_attendances: {
      name: "Participation |||| Participations",
      fields: {
        comment: "Commentaire",
        has_attended: "Participé",
      },
      actions: {
        add_absence: "Ajouter absence",
        edit_absence: "Modifier absence",
        add_comment: "Ajouter commentaire",
        edit_comment: "Modifier commentaire",
        mark_attended: "Marquer comme participé",
        mark_unattended: "Marquer comme absent",
      },
      hints: {
        has_attended: "A participé",
        has_not_attended: "N'a pas participé",
        has_attended_count: "A participé à %{attendedCount} de %{attendedMax} sous-événements",
      },
    },
    attendance_absences: {
      name: "Absence |||| Absences",
      fields: {
        absence_start: "Début de l'absence",
        absence_end: "Fin de l'absence",
      },
      validation: {
        start_time_before: "Le début de l'absence doit être avant %{maxTime}",
        start_time_after: "Le début de l'absence doit être après %{minTime}",
        end_time_after: "La fin de l'absence doit être avant %{maxTime}",
        start_time_before_end_time: "Le début de l'absence doit précéder la fin de l'absence",
        end_time_after_start_time: "La fin de l'absence doit suivre le début de l'absence",
      },
    },
    attendees: {
      name: "Participant*e |||| Participant*es",
      fields: { ...userFields, with: "Participant*e", attendee_number: "Numéro de client" },
      actions: {
        update_contact_infos: "Mettre à jour les informations de contact",
        add_main_contact_info: "Communication",
        add_invoice_contact_info: "Facture",
        add_invoice_dispatch_contact_info: "Expédition de factures",
        enroll_to_moodle_courses: "Inscrire au(x) cours Moodle",
        add_new_interested: "Créer un(e) nouveau/nouvelle intéressé(e)",
        add_new: "Créer une nouvelle personne",
        add_existing: "Personnes existantes",
        copy_main_contact_info: "Adopter l'adresse de communication",
        show_more_fields: "Afficher plus de champs",
        add_to_list: "Ajouter à la liste",
        add_to_organization: "Ajouter à l'organisation",
      },
      hints: {
        booking_documents_at_booking: "Les documents de réservation se trouvent à la réservation correspondante.",
        debit_number_taken:
          "est déjà utilisé par d'autres personnes. Veuillez vous assurer que c'est ce que vous souhaitez.",
      },
      is_archived: "Participant(e) est archivé(e)",
      removed: "La personne est supprimée",
    },
    audiences: {
      name: "Public cible |||| Publics cibles",
      fields: {
        name: "Nom",
      },
    },
    auth_groups: {
      name: "Groupe d'autorisation |||| Groupes d'autorisation",
    },
    customer: {
      name: "Profil client |||| Profils clients",
      fields: {
        name: "Nom",
        value_added_tax_id: "Numéro d'identification TVA",
        trade_register_number: "Numéro de registre du commerce",
        fiscal_number: "Numéro fiscal",
        iban: "IBAN",
      },
      hints: {
        no_customer_created_yet: "Aucun profil client n'a été créé.",
      },
      sections: {
        general: "Général",
        invoicing: "Facturation",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
    },
    contact_persons: {
      name: "Personne de contact |||| Personnes de contact",
    },
    user_roles: {
      name: "Groupe d'autorisation |||| Groupes d'autorisation",
      fields: {
        name: "Nom",
        permission_groups: "Autorisations",
      },
      auth_groups: {
        default: "Accès à l'interface",
        manage_events: "Gérer les événements",
        manage_event_bases: "Gérer les offres",
        manage_orders: "Gérer les commandes",
        manage_users: "Gérer les utilisateurs",
        manage_attendees: "Gérer les participants",
        manage_interests: "Gérer les intéressés",
        manage_lecturers: "Gérer les enseignants",
        manage_todos_and_responsibilities: "Gérer les tâches et responsabilités",
        manage_bookings: "Gérer les réservations",
        manage_moodle: "Gérer Moodle",
        manage_invoices: "Gérer les factures",
        manage_access: "Gérer l'accès EDM",
        manage_templates: "Gérer les modèles",
        manage_settings: "Gérer les paramètres",
        manage_base_data: "Gérer les données de base",
        manage_organizations: "Gérer les organisations",
        view_accounting: "Voir la comptabilité EDM",
        view_reporting: "Voir le rapport",
        view_booking_list: "Voir la liste des réservations",
        view_invoice_list: "Voir la liste des factures",
        manage_accounting: "Comptabilité",
        manage_event_feedback: "Gérer les retours d'événements",
        view_feedback_report: "Voir le rapport de retour",
        attendee: "Autorisations pour les participants",
        lecturer: "Autorisations pour les enseignants",
      },
      headlines: {
        permission_info: "Description des autorisations",
      },
    },
    auth_users: {
      name: "Connexion",
      fields: {
        email: "E-mail",
      },
    },
    bookings: {
      name: "Réservation |||| Réservations",
      fields: {
        event_date_attendances: "Présence",
        has_attended: "Participé",
        price_positions: "Positions de prix",
        attendee: "Participant*e",
        booking_number: "Numéro de réservation",
        status: "Statut",
        created_at: "Réservé le",
        format: "Format de participation",
        first_name: "Prénom",
        last_name: "Nom",
        event: "Événement",
        event_id_number: "Numéro de l'événement",
        amount: "Montant",
        price: "Prix",
        invoices: "Facture",
        invoiced_amount: "Facturé",
        price_amount: "Montant",
        price_name: "Nom du prix",
        attendee__last_name: "Nom",
        price__price_type__name: "Type de prix",
        order_item__order__order_number: "Numéro de commande",
        order: "Commande",
      },
      calculated_fields: {
        cleared: "Facturé",
        paid: "payé",
        attended: "Participé",
      },
      actions: {
        invoices_menu: "Facture",
        change_status: "Changer le statut",
        create_invoices: "Créer une facture |||| Créer des factures",
        download_invoices: "Télécharger la facture |||| Télécharger les factures",
        send_invoices: "Envoyer la facture |||| Envoyer les factures",
        delete_invoices: "Supprimer la facture |||| Supprimer les factures",
        edit_invoices: "Modifier la facture |||| Modifier les factures",
        send_mail_to_all_bookings: "E-mail à tous",
        send_mail_to_all_bookings_VALID: "%{bookingCount} participants inscrits",
        send_mail_to_all_bookings_WAITING: "%{bookingCount} participants en attente",
        send_mail_to_all_bookings_CANCELED: "%{bookingCount} participants annulés",
        send_mail_to_all_lecturers: "%{lecturerCount} enseignants",
        edit_attendance: "Modifier la participation",
        mark_as_attended: "Marquer comme ayant participé",
        mark_as_unattended: "Marquer comme n'ayant pas participé",
        add_as_interests: "Ajouter aux intéressés",
        alter_bookings: "Replanifier",
        use_existing_price_type: "Utiliser le type de prix existant",
        use_custom_fields_data: "Adopter les champs de réservation avancés",
        visit_website: "Vers le site web",
        bill_to_other: "Attribuer la commande à une organisation / une autre personne",
        delete: "Supprimer la réservation |||| Supprimer les réservations",
      },
      hints: {
        deleted: "Réservation supprimée |||| Réservations supprimées",
        delete_explanation:
          "La réservation est supprimée définitivement et sa position de commande redevient non traitée. |||| Les réservations sont supprimées définitivement et leurs positions de commande redeviennent non traitées.",
        bill_to_other:
          "Par défaut : une commande distincte par personne. Activez pour regrouper tous les participants dans une seule commande facturée à une organisation ou à une autre personne.",
        override_validation: "Ignorer les vérifications de disponibilité (capacité, etc.) et autoriser le surbooking.",
      },
      tooltips: {
        has_attended_event: "a participé à l'événement",
        has_attended_group_events: "a participé à %{attendedCount} sur %{attendedMax} sous-événements",
      },
      labels: {
        created_at: "inscrit le",
        rebooked_to: "reprogrammé vers",
        rebooked_from: "reprogrammé de",
        booking_data: "Données de réservation",
        fallback_price: "Prix (secours)",
        is_archived: "Cette réservation est archivée",
        no_bookings: "Aucune réservation disponible.",
      },
      status: {
        VALID: "Inscrit",
        CANCELED: "Annulé",
        WAITING: "Liste d'attente",
        REBOOKED: "Réinscrit",
      },
    },
    categories: {
      name: "Catégorie |||| Catégories",
      fields: {
        name: "Nom",
        parent_category: "Catégorie parente",
        parent_category_name: "Nom de la catégorie parente",
      },
      is_archived: "Cette catégorie est archivée",
    },
    checkouts: {
      name: "Checkout |||| Checkouts",
      fields: {
        checkout_id: "ID de checkout",
        payment_id: "ID de paiement",
      },
    },
    consents: {
      name: "Consentement |||| Consentements",
      fields: {
        is_confirmed: "Confirmé",
        timestamp: "Créé le",
        order_number: "Numéro de commande",
        additional_info: "Informations supplémentaires",
      },
      hints: {
        confirmation_thank_you: "Merci d'avoir confirmé !",
      },
    },
    consent_types: {
      name: "Type de consentement |||| Types de consentement",
      fields: {
        name: "Nom",
        scope: "Portée",
        needs_confirmation: "Nécessite une double confirmation",
        welcome_mail_template: "Modèle d'e-mail après consentement",
        confirmation_mail_template: "Modèle d'e-mail de consentement",
        redirect_url: "URL de redirection",
        description: "Description",
        show_in_registration_form: "Afficher dans le formulaire d'inscription",
        registration_text: "Texte du formulaire d'inscription",
      },
    },
    contexts: {
      name: "Environnement |||| Environnements",
      fields: {
        name: "Nom",
      },
    },
    content_types: {
      name: customFieldContentTypeName,
    },
    customer_invoices: {
      name: "Facturation |||| Facturation",
      fields: {
        id: "Numéro de facturation",
        to_datetime: "Réservations jusqu'au",
        from_datetime: "Réservations à partir de",
        minimum_price_per_month: "Prix minimum par mois",
        created_at: "Créé le",
        discount: "Remise",
        positions: "Postes de réservation",
        commission_sum: "Montant de la commission",
        commission_per_month: "Commission fixe par mois",
        invoice_sum: "Montant total",
        attendee_name: "Participant(e)",
        booking_number: "Numéro de réservation",
        order_number: "Numéro de commande",
        event_name: "Événement",
        booking_amount: "Montant de la réservation",
        commission: "Commission",
        positions_count: "Nombre de postes de réservation",
      },
      labels: {
        minimum_amount: "Montant minimum",
      },
      filters: {
        negative_commission_only: "Afficher uniquement les montants de commission négatifs",
      },
    },
    custom_field_select_values: {
      name: "Valeurs de sélection (Champs personnalisés)",
    },
    dashboard: {
      name: "Tableau de bord",
    },
    custom_fields_data: {
      name: customFieldContentTypeName,
      fields: {
        value: "Valeur",
      },
    },
    descriptions: {
      name: "Description |||| Descriptions",
      fields: {
        id: "ID",
        text: "Texte",
        slug: "Slug",
      },
    },
    document_templates: {
      name: "Modèle de document |||| Modèles de document",
      label: "Modèle de document",
      templateVersions: "Versions des modèles",
      version: "Version %{version}",
      input: {
        upload_version: "Télécharger une nouvelle version",
        store_permanently: "Sauvegarder à %{scope}",
        show_custom_content: "Ajouter du contenu personnalisé",
        hide_custom_content: "Masquer le contenu personnalisé",
        custom_content: "Contenu personnalisé",
      },
      actions: {
        showMoreVersions: "Afficher toutes les versions",
        showLessVersions: "Moins",
        generate: "Créer des documents",
        save_and_close: "Enregistrer & Fermer",
        save_and_send: "Enregistrer & Envoyer",
        download_all: "Télécharger en lot",
        example_menu: "Exemples",
      },
      related_resource: {
        BOOKING_TEMPLATE: "Réservation",
        EVENT_TEMPLATE: "Événement",
        EVENT_BASE_TEMPLATE: "Offre",
        ATTENDEE_TEMPLATE: "Participant*e",
        LECTURER_TEMPLATE: "Enseignant*e",
        INVOICE_TEMPLATE: "Facture",
        ORGANIZATION_TEMPLATE: "Organisation",
        EVENT_LOCATION_TEMPLATE: "Lieu de l'événement",
      },
      fields: {
        original_filename: "Nom de fichier",
        related_resource: "Contexte",
        created_at: "Créé le",
        language: "Langue",
        parent_template: "Modèle supérieur",
      },
      notification: {
        only_ms_word_files_allowed: "Type de fichier invalide. Autorisés : .docx et .doc",
        successfully_generated:
          "%{smart_count} document a été généré avec succès |||| %{smart_count} documents ont été générés avec succès",
        generation_finished: "Génération du document terminée |||| Génération de documents terminée",
        generation_in_progress: "Document en cours de génération |||| Documents en cours de génération",
        generation_other_pending:
          "%{smart_count} autre document généré en premier |||| %{smart_count} autres documents générés en premier",
        generation_error: "Erreur lors de la génération du document |||| Erreur lors de la génération des documents",
        persist_success: "Les documents ont été enregistrés de manière permanente",
        persist_error: "Erreur lors de l'enregistrement des documents",
        no_templates_present: "Aucun modèle n'est disponible pour cette section.",
      },
      document_types: {
        participation_certificate: "Certificat de participation",
        name_plates: "Badges nominatifs",
      },
    },
    edm_moodle_enrollments: {
      name: "Inscription Moodle |||| Inscriptions Moodle",
    },
    enrollments: {
      name: "Inscription |||| Inscriptions",
      fields: {
        ...userFields,
        approval_url: "Lien d'approbation",
        approval_status: "Approbation",
        approval_reason: "Motif",
      },
    },
    orders: {
      name: "Commande |||| Commandes",
      fields: {
        id: "ID",
        status: "Statut",
        order_number: "Numéro de commande",
        buyer: "Acheteur/-euse",
        organization: "Organisation",
        user: "Personne acheteuse",
        payment_provider: "Mode de paiement",
        is_paid: "Payé",
        is_fully_invoiced: "Entièrement facturé",
        is_self_order: "Auto-inscription",
        total: "Total",
        buyer_note: "Note de la personne acheteuse",
        your_note: "Votre note",
        note: "Votre note",
        open_items: "Positions ouvertes",
        item_count: "Articles",
        events: "Événements",
        created_at: "Créé le",
      },
      filters: {
        has_processable_items: "À traiter",
        person: "Acheteur ou participant",
        event: "Événement",
      },
      status: {
        pending: "En attente",
        confirmed: "Confirmé",
        canceled: "Annulé",
      },
      payment_status: {
        pending: "En attente",
        failure: "Échoué",
        completed: "Terminé",
      },
      checkout_failure_reason: {
        cancel_redirect: "L'acheteur a interrompu le paiement. Les places réservées ont été libérées.",
        expired_webhook: "Le délai de paiement a expiré. Les places réservées ont été libérées.",
      },
      payment_provider: {
        stripe: "Carte de crédit (Stripe)",
        edm_invoice: "Facture",
      },
      buyer_type: {
        user: "Personne",
        organization: "Organisation",
      },
      roles: {
        buying_person: "Personne acheteuse",
        organization: "Organisation acheteuse",
        attendee: "Participants",
      },
      headlines: {
        custom_fields: "Champs personnalisés",
        buyer: "Acheteur/-euse",
        summary: "Aperçu",
        cancellation_email: "E-mail d'annulation",
      },
      actions: {
        edit: "Modifier la commande",
        create: "Créer une commande",
        confirm: "Confirmer",
        cancel: "Annuler",
        delete: "Supprimer la commande",
        create_invoice: "Créer une facture",
        create_invoices: "Créer des factures",
        quick_book_all: "Réservation rapide de tout (%{count})",
        quick_book: "Réservation rapide de tout",
        override_validation: "Ignorer les vérifications (surréserver)",
        create_credit_note: "Créer un avoir (correction/contre-passation)",
        refund: "Rembourser le paiement",
        email_buyer: "E-mail à l'acheteur",
        email_attendees: "E-mail aux participants",
        email_buyers: "E-mail aux acheteurs",
        email_attendees_disabled:
          "Aucune des positions sélectionnées n'a de réservation - il n'y a aucun participant à contacter.",
        resume_checkout: "Payer maintenant",
      },
      hints: {
        ordered_at_by: "commandé le %{date} par",
        ordered_at: "du %{date}",
        confirmed: "Commande confirmée",
        canceled: "Commande annulée",
        deleted: "Commande supprimée",
        delete_explanation:
          "La commande et toutes ses positions sont supprimées définitivement, comme si elles n'avaient jamais existé. Si la commande a réellement eu lieu, annulez-la à la place.",
        delete_blocked:
          "Cette commande peut seulement être annulée, pas supprimée : une facture, une tentative de paiement ou une réservation existe.",
        invoice_created: "Facture créée",
        invoice_ready: "La facture et son document sont prêts.",
        invoice_document_failed:
          "Le document n'a pas pu être généré, la facture a donc été supprimée. Vérifiez le modèle de facture et créez à nouveau la facture.",
        document_ready: "Document prêt",
        document_missing: "Aucun document généré",
        skipped_item: "Position #%{id} : %{reason}",
        skipped_item_of_order: "%{order} : %{reason}",
        created: "Commande créée",
        buyer_without_billing_address:
          "Cet acheteur n'a pas d'adresse de facturation (rue, code postal et ville). Aucune facture ne peut être générée pour la commande.",
        processed: "Positions réservées",
        search: "Rechercher un numéro de commande ou une organisation",
        more_events: "Autres événements",
        confirm_explanation:
          "La commande devient ferme. Les réservations sont créées et des factures peuvent être générées.",
        confirm_prepaid_explanation:
          "Commande prépayée : la confirmer sans paiement abouti crée les réservations et envoie les confirmations immédiatement, et les places ne sont plus libérées automatiquement. Aucune facture n'est créée ici - émettez-la explicitement. Un paiement ultérieur reste facturé automatiquement.",
        checkout_failed: "Paiement échoué – commande annulée",
        create_invoice_explanation: "Ces lignes seront facturées.",
        bulk_create_invoice_explanation:
          "Les réservations sélectionnées sont regroupées en une facture par commande (%{smart_count} commande(s)). Les positions annulées ou déjà facturées sont ignorées.",
        bulk_create_order_invoice_explanation:
          "Une facture est créée par commande sélectionnée (%{smart_count} commande(s)), couvrant toutes les positions confirmées et pas encore facturées. Les commandes entièrement facturées ou non confirmées sont ignorées.",
        bulk_order_invoice_nothing_selected: "Sélectionnez au moins une commande.",
        bulk_create_item_invoice_explanation:
          "Les positions sélectionnées sont regroupées en une facture par commande (%{smart_count} commande(s)). Les positions annulées ou déjà facturées sont ignorées.",
        bulk_item_invoice_nothing_selected: "Sélectionnez au moins une position.",
        bulk_invoice_overrides:
          "Remplacements facultatifs appliqués à toutes les factures créées. Laisser vide et chaque facture conserve son propre modèle, titre et période de prestation résolus.",
        bulk_invoice_default_placeholder: "Valeur par défaut par commande",
        bulk_invoice_bookings_without_order:
          "%{smart_count} réservation(s) sélectionnée(s) ne sont pas liées à une commande et ne peuvent pas être facturées.",
        bulk_invoice_nothing_selected: "Aucune des réservations sélectionnées ne peut être facturée.",
        bulk_invoice_missing_addresses:
          "Une commande n'a pas d'adresse de facturation utilisable et sera ignorée : %{orders} |||| %{smart_count} commandes n'ont pas d'adresse de facturation utilisable et seront ignorées : %{orders}",
        bulk_invoices_created: "%{smart_count} facture créée |||| %{smart_count} factures créées",
        bulk_invoices_skipped:
          "%{smart_count} position(s) ont été ignorées (annulées, déjà facturées ou non confirmées).",
        create_custom_invoice_explanation:
          "Toutes les positions sont déjà facturées. Ajoutez des lignes ci-dessous pour créer une facture personnalisée.",
        invoice_recipient_without_address:
          "%{name} n'a pas d'adresse de facturation utilisable (rue, code postal et ville). Complétez les informations de facturation ci-dessous, sinon aucune facture ne peut être créée.",
        invoice_nothing_selected: "Ajoutez au moins une ligne à facturer.",
        partially_processed: "%{count} positions ont été réservées. Les autres sont listées ci-dessous.",
        process_order_explanation:
          "Crée une réservation pour les %{count} positions ouvertes et assignées de cette commande. Les positions sans participant sont ignorées.",
        override_validation: "Ignorer les vérifications de disponibilité (capacité, etc.) et autoriser le surbooking.",
        override_validation_create:
          "Ignorer les vérifications (capacité, délai d'inscription) à la création, pour surréserver.",
        override_validation_shortcut:
          "Raccourci : maintenir Maj en cliquant sur l'action pour l'activer uniquement pour ce clic.",
        change_buyer:
          "L'acheteur ne peut être modifié que tant qu'aucune facture n'existe. Les participants des positions ne sont pas modifiés automatiquement.",
        cancel_explanation: "Toute la commande est annulée ainsi que les réservations associées.",
        bulk_cancel_explanation:
          "%{smart_count} commande(s) sont annulées avec toutes leurs positions et réservations. Les commandes déjà annulées sont ignorées.",
        bulk_canceled: "Commandes annulées",
        bulk_cancel_skipped_entry: "#%{id} : %{reason}",
        bulk_cancel_nothing_open: "Plus rien à annuler : la sélection est déjà annulée.",
        bulk_cancel_no_credit_notes:
          "Aucun avoir n'a été créé : les factures concernées sont déjà corrigées ou annulées.",
        cancel_event_started: "Événement(s) déjà commencé(s) :",
        cancel_event_finished: "Événement(s) déjà terminé(s) :",
        cancel_event_elearning:
          "E-learning sans date fixe. Il a peut-être déjà commencé ou l'accès a peut-être déjà été accordé :",
        no_invoices: "Aucune facture.",
        attendees: "Une position de commande est créée par personne sélectionnée.",
      },
      labels: {
        no_orders: "Vous n'avez pas encore de commandes.",
        item_count: "%{smart_count} position |||| %{smart_count} positions",
        seat_count: "%{smart_count} place |||| %{smart_count} places",
        more_events: "+ %{smart_count} autre événement |||| + %{smart_count} autres événements",
        self_buyer: "Vous-même",
        document: "Document",
      },
    },
    order_items: {
      name: "Position de commande |||| Positions de commande",
      processing_queue: "À traiter",
      labels: {
        no_items: "Cette commande n'a aucune position.",
      },
      filters: {
        processing_queue: "Vue",
        queue_open: "Éléments ouverts",
        queue_open_and_requests: "Éléments ouverts et annulations demandées",
        queue_processed: "Éléments traités",
        cancellation_requested: "Annulation demandée",
      },
      fields: {
        id: "ID",
        approval_url: "Lien d'approbation",
        is_third_party: "Réservé pour une autre personne",
        price_type_name: "Type de prix",
        approval_emails: "E-mails des approbateurs",
        state: "Statut",
        user: "Participant/-e",
        event: "Événement",
        price: "Prix",
        offered_price: "Offre",
        adjust_price: "Ajuster le prix",
        invoiced_amount: "Facturé",
        attendees: "Participants",
        format: "Format",
        approval_status: "Approbation",
        approval_reason: "Motif",
        cancellation_reason: "Motif de l'annulation (facultatif)",
        canceled_at: "Annulé le",
        created_at: "Créé le",
        price_amount: "Prix",
      },
      state: {
        open: "Ouvert",
        booked: "Réservé",
        denied: "Refusé",
        canceled: "Annulé",
      },
      approval: {
        pending: "Approbation en attente",
        approved: "Approuvé",
        denied: "Refusé",
      },
      actions: {
        use_different_person: "Autre participant",
        use_buyer_as_attendee: "L'acheteur participe",
        adjust_price: "Ajuster le prix",
        use_offer_price: "Utiliser le prix de l'offre",
        add: "Ajouter une position",
        add_and_book: "Réserver directement",
        edit: "Modifier la position",
        edit_person_data: "Modifier les données de la personne",
        edit_main_contact_info: "Modifier les coordonnées",
        edit_invoice_contact_info: "Modifier l'adresse de facturation",
        edit_invoice_dispatch_contact_info: "Modifier l'adresse d'envoi de facture",
        use_from_source: "Copier depuis la commande",
        show_booking: "Vers la réservation",
        show_item: "Ouvrir la ligne de commande",
        use_custom_fields_and_confirm: "Copier les champs et utiliser",
        request_approval: "Demander l'approbation",
        process: "Proceso",
        create_booking: "Créer la réservation",
        create_waiting_list_booking: "Créer une réservation en liste d'attente",
        use_person: "Utiliser cette personne",
        linked: "Liée",
        assign: "Attribuer une personne",
        reassign: "Réattribuer une personne",
        cancel: "Annuler",
        request_cancellation: "Demander l'annulation",
        request_cancellation_confirm:
          "Demander l'annulation de cette position ? La demande est examinée, rien n'est annulé automatiquement.",
        request_cancellation_confirm_button: "Demander l'annulation",
        request_cancellation_success: "La demande d'annulation a été envoyée.",
        request_cancellation_error: "La demande d'annulation a échoué. Veuillez réessayer.",
        cancellation_requested: "Annulation demandée",
        delete: "Supprimer la position",
        open_processing: "Traiter",
        quick_process: "Réservation rapide",
        previous_item: "Position précédente",
        next_item: "Position suivante",
      },
      headlines: {
        custom_fields: "Champs personnalisés",
        lists: "Listes",
        consents: "Consentements",
        buyer: "Acheteur",
        buyer_and_attendee: "Acheteur et participant",
        matching_persons: "Participants existants",
        processing: "Traiter la position de commande",
        attendee: "Participant/-e",
        purchase: "Offre réservée",
        other_items: "Autres positions de cette commande",
        person: "Personnes",
      },
      hints: {
        event_fully_booked:
          "Le nombre maximum de participants pour cet événement (ou pour un sous-événement) est déjà atteint.",
        added: "Position ajoutée",
        add_blocked_canceled: "Une commande annulée ne peut plus être complétée.",
        add_blocked_prepaid:
          "Une commande prépayée ne peut pas être complétée. Créez une commande distincte pour la position supplémentaire.",
        price_locked_prepaid:
          "Cette commande est prépayée. Son prix ne peut plus être modifié : la page de paiement facture le montant avec lequel la commande a été créée. Créez plutôt une commande distincte.",
        cancel_prepaid:
          "Cette commande est prépayée. Une annulation ne change pas le montant que sa page de paiement facture ou a déjà facturé : rapprochez le paiement manuellement ensuite.",
        add_to_confirmed_order:
          "Cette commande est déjà confirmée. La nouvelle position n'est pas facturée automatiquement : la facturation reste une étape distincte.",
        book_requires_confirmed_order: "La réservation n'est possible qu'une fois la commande confirmée.",
        edit_invoiced_item:
          "Cette position est déjà facturée. Un changement de prix n'est ni facturé ni crédité automatiquement : émettez une autre facture ou un avoir pour la différence.",
        thank_you_headline: "Merci! Vos données ont été transmises avec succès.",
        approval: "Approuver",
        mismatch_in_person_data:
          "Les données enregistrées diffèrent de celles de cette personne. Copier les valeurs enregistrées ou conserver les existantes ?",
        request_approval_explanation:
          "Envoie la demande d'approbation aux adresses indiquées. Chaque approbateur reçoit un lien signé pour approuver ou refuser.",
        approval_requested: "Demande d'approbation envoyée",
        approval_emails: "Séparez plusieurs adresses par des virgules.",
        open_items_count: "%{count} élément ouvert |||| %{count} éléments ouverts",
        cancellation_requested: "Une annulation a été demandée pour cette position. À vérifier avant de la réserver.",
        processed_items_count: "%{count} élément traité |||| %{count} éléments traités",
        no_processable_items: "Aucun élément à traiter.",
        no_processed_items: "Aucun élément traité.",
        unassigned: "Non attribué",
        bulk_cancel_explanation:
          "%{smart_count} position(s) sont annulées avec leurs réservations. Les commandes conservent leur statut et leurs autres positions ne sont pas modifiées.",
        bulk_canceled: "Positions annulées",
        processed: "Position réservée",
        assigned: "Personne attribuée",
        canceled: "Position annulée",
        deleted: "Position supprimée",
        delete_explanation:
          "La position est supprimée définitivement, comme si elle n'avait jamais existé. Si elle a réellement eu lieu, annulez-la à la place.",
        delete_blocked:
          "Cette position ne peut pas être supprimée : elle est réservée ou facturée, ou c'est la dernière position de la commande (supprimez la commande à la place).",
        cancel_explanation: "Cette position est annulée ainsi que les réservations associées.",
        process_explanation: "Créer une réservation pour %{name} dans %{event}.",
        quick_process:
          "Réservation rapide pour les positions déjà attribuées. Pour le rapprochement de doublons ou l'attribution, ouvrez la page de traitement.",
        approval_denied: "Cette position a été refusée et ne peut pas être réservée.",
        matching_persons:
          "Personnes existantes ayant un nom ou un e-mail correspondant. Liez-en une pour éviter les doublons.",
        no_matching_persons: "Aucune personne correspondante trouvée.",
        person_used: "Utilisé",
        approval_for: "Approbation de l'inscription",
      },
    },
    emails: {
      name: "E-mail |||| E-mails",
      single_emails: "E-mails individuels",
      is_archived: "Cet e-mail est archivé",
      fields: {
        subject: "Sujet",
        template: "Modèle",
        created_at: "Créé le",
        status: "Statut",
        to: "À",
        bounce_reason: "Raison du rejet",
        scheduled_at: "Date d’envoi",
      },
      status: {
        waiting_for_transfer: "En attente de transfert",
        transfered: "Transféré",
        sent: "Envoyé",
        blocked: "Bloqué",
        error: "Erreur d’envoi",
      },
      actions: {
        resend: "Renvoyer",
      },
      hints: {
        undeliverableEmails: "Un courriel ne sera pas délivré |||| %{smart_count} courriels ne seront pas délivrés",
        duplicateRecipients:
          "Une adresse reçoit plusieurs courriels |||| %{smart_count} adresses reçoivent plusieurs courriels",
        noEmailAddress: "Pas d'adresse électronique disponible",
        noListConsentGiven: "Aucun consentement n'a été donné pour la liste",
      },
    },
    email_jobs: {
      name: "Envoi d’e-mail |||| Envois d’e-mails",
      is_archived: "Cet envoi d’e-mail est archivé",
      fields: {
        created_at: "Créé le",
        sender: "Adresse de l’expéditeur",
        body: "Contenu",
        emails: "À",
        attachments: "Pièces jointes",
        recipients: "Destinataires",
        template: "Modèle",
        created_by: "Créé par",
        custom_to: "Adresse e-mail",
      },
      actions: {
        group_by_jobs: "Grouper par envoi",
      },
    },
    email_senders: {
      name: "Expéditeur d'e-mail",
      fields: {
        name: "Nom",
        email: "E-mail",
        signature: "Signature",
        users: "Personnel autorisé",
        lecturers: "Conférenciers autorisé",
        external_id: "ID externe",
        use_for_reply: "Utiliser pour la réponse",
      },
    },
    event_lecturers: {
      name: "Enseignant*e |||| Enseignants",
    },
    events: {
      name: "Événement |||| Événements",
      name_singular: "Événement",
      is_archived: "Cet événement est archivé",
      invalid_archive_filter: 'Le filtre Archivé est réglé sur "Tous". Archivage impossible.',
      array_input_fields: {
        dates: "Dates et heures",
        group_children: "Événement |||| Événements",
        group_parents: "Groupe d'événements |||| Groupes d'événements",
        prices: "Prix |||| Prix",
        lecturers: "Conférencier |||| Conférenciers",
      },
      bulk_update_dates: {
        has_day: "Modifier le jour",
        has_time: "Modifier l'heure",
        has_format: "Modifier le format",
        has_location: "Modifier le lieu",
      },
      fields: {
        id: "ID",
        attendees_max: "Participants max.",
        attendees_min: "Participants min.",
        capacity: "Capacité",
        child_event_base: "Offre",
        cost_center: "Centre de coûts",
        cost_object: "Objet de coût",
        project_number: "Numéro de projet",
        created_at: "Créé",
        event_base: "Offre",
        event_base_group_parent: "Groupe d'offres",
        group_parent: "Groupe d'événements",
        group_child: "Événement",
        external_url: "URL publique",
        first_day: "Date",
        last_day: "Dernier jour de l'événement",
        first_day_end_time: "Fin de la date",
        first_day_start_time: "Début de la date",
        id_number: "Numéro",
        inventory_account: "Compte d'inventaire",
        is_bookable: "Réservable",
        format: "Format de l'événement",
        is_solo_bookable: "Réservable individuellement",
        lecturers: "Enseignants",
        location: "Lieu de l'événement",
        meta: {
          event_base_category_names: "Catégories",
          event_base_name: "Titre de l'offre",
          event_base_type_name: "Type d'offre",
          all_valid_bookings_count: "Chiffres de participation",
        },
        online_invite_text: "Informations sur la réunion",
        prices: "Prix",
        registration_begin: "Période d'inscription : Début",
        registration_deadline: "Période d'inscription : Fin",
        remaining_dates: "Autres dates",
        responsibilities: "Responsabilités",
        responsible_persons: "Personnes responsables",
        is_public: "Public",
        rooms: "Salles",
        status: "Statut",
        lecturers_may_edit_attendance: "Les enseignants peuvent modifier la participation",
        display_in_portal: "Visible dans le portail",
        is_billable: "Est facturable",
        bookings: "Réservations",
        event_location_name: "Nom du lieu de l'événement",
        event_lecturer_names: "Noms des enseignants",
        all_valid_bookings_count: "Nombre de réservations valides",
        all_waiting_bookings_count: "Nombre de réservations en attente",
        is_child: "Événement dans un groupe",
        is_parent: "Groupe d'événements",
        dates_count: "Nombre de dates",
        dates: "Dates",
        event_base__name: "Titre de l'offre",
        event_base__event_type__name: "Type d'offre",
        location__name: "Lieu de l'événement",
      },
      actions: {
        new_event: "Créer nouveau",
        existing_event: "Reprendre les données",
        create_event: "Créer un événement",
        change_status: "Changer le statut",
        bulk_update: "Mettre à jour les champs",
        change_format: "Changer le format",
        change_event_base: "Modifier l'offre",
        create_booking: "Ajouter une réservation",
        create_bookings: "Ajouter des réservations",
        select_persons: "Sélectionner des personnes",
        select_event: "Sélectionner un événement",
        create_interest: "Ajouter un intéressé*e",
        create_group: "Grouper",
        add_moodle_course: "Lier le cours Moodle",
        remove_moodle_course: "Retirer le lien du cours Moodle",
        show_event_base: "À l'offre",
        add_to_event_group: "Ajouter au groupe",
        add_child_event_to_group: "Ajouter un événement",
        duplicate: "Dupliquer",
        add_lecturer: "Ajouter un*e enseignant*e",
        add_new_lecturer: "Créer et attribuer un*e enseignant*e",
        connect_existing_lecturer: "Attribuer un*e enseignant*e",
        edit_accounting_fields: "Modifier les champs comptables",
        edit_responsibilities: "Modifier les responsabilités pour « %{responsibilityType} »",
        update_children_status: "Mettre à jour également le statut de tous les événements subordonnés",
        add_feedback_form: "Ajouter un formulaire de feedback",
        update_dates: "Modifier les dates",
      },
      validation: {
        number_not_unique: "Le numéro de l'événement est déjà utilisé",
      },
      headlines: {
        cancel_order_items: "Annuler les positions de commande",
      },
      hints: {
        cancel_order_items_explanation:
          "L'événement est annulé. %{smart_count} position(s) de commandes confirmées y sont encore réservées. Les annuler avec leurs réservations ? Les positions d'autres événements de la même commande ne sont pas modifiées.",
      },
    },
    event_bases: {
      name: "Offre |||| Offres",
      name_singular: "Offre",
      is_archived: "Cette offre est archivée",
      fields: {
        image_path: "Chemin de l'image",
        name: "Nom",
        slug: "Segment URL",
        summary: "Résumé",
        event_type: "Type",
        event_type_name: "Nom du type d'événement",
        contact_persons: "Personnes de contact",
        group_parent: "Groupe d'offres",
        partners: "Partenaires de coopération",
        tags: "Mots-clés",
        contexts: "Environnements",
        categories: "Catégories",
        audiences: "Publics cibles",
        descriptions: "Descriptions",
        image: "Image",
        documents: "Documents",
        created_at: "Créé",
        updated_at: "Mis à jour",
        external_url: "URL publique",
        event_count: "Nombre d'événements",
        event_type__name: "Type",
      },
      actions: {
        duplicate: "Dupliquer",
        new_event_base: "Nouvelle offre",
        existing_event_base: "Offre existante",
        change_event_type: "Changer le type d'offre",
        create_event: "Ajouter un événement",
        create_event_base: "Créer une offre",
        create_event_base_child: "Créer une sous-offre",
        create_event_group: "Créer un groupe d'événements",
        show_event_base_group: "À la groupe d'offres",
        add_description_field: "Ajouter un champ",
        show_old_descriptions: "Afficher les anciennes descriptions",
        hide_old_descriptions: "Masquer les anciennes descriptions",
      },
    },
    event_base_descriptions: {
      name: "Description de l'offre |||| Descriptions des offres",
      fields: {
        description_type: "Type de description",
        text: "Texte",
      },
    },
    event_base_description_fields: {
      name: "Champ de description |||| Champs de description",
      fields: {
        label: "Étiquette",
        slug: "Identifiant",
        field_type: "Type de champ",
        width: "Largeur",
        show_per_default: "Toujours afficher",
        soft_required: "Requis",
      },
    },
    event_dates: {
      name: "Date |||| Dates",
      fields: {
        has_attended: "Participé",
        id: "ID",
        event: "Événement",
        day: "Jour",
        different_location: "Lieu différent",
        start_time: "Début (heure)",
        end_time: "Fin (heure)",
        start_datetime: "Début",
        end_datetime: "Fin",
        location: "Lieu différent",
        format: "Format différent",
      },
      headlines: {
        date: "Date",
        date_details: "Détails de la date",
      },
      formats: {},
    },
    event_feedback_forms: {
      name: "Formulaire de feedback de l'événement |||| Formulaires de feedback des événements",
      fields: {
        event: "Événement",
        valid_until: "Valable jusqu'à",
        feedback_form: "Formulaire de feedback",
        url: "URL du formulaire",
        name: "Nom du formulaire",
        reporting_visible_for_lecturers: "Évaluation accessible aux enseignants",
      },
      actions: {
        download_qr_code: "Télécharger le code QR",
        remove_from_event: "Retirer de l'événement",
        edit: "Modifier le formulaire de feedback",
      },
      labels: {
        additional_text: "Explication",
        add_text_response: "Ajouter une réponse textuelle",
      },
    },
    event_locations: {
      name: "Lieu de l'événement |||| Lieux de l'événement",
      fields: {
        image_path: "Chemin de l'image",
        name: "Nom",
        email: "E-mail",
        rooms: "Salles",
        url: "URL",
        lat: "Latitude",
        lon: "Longitude",
        info: "Information",
        address: userFields.contact_info,
      },
    },
    event_moodle_courses: {
      name: "Lien de cours Moodle |||| Liens de cours Moodle",
      actions: {
        disconnect_moodle_course: "Dissocier le lien de cours Moodle",
      },
    },
    event_rooms: {
      name: "Salle d'événement |||| Salles d'événement",
      fields: {
        identifier: "Identifiant de salle",
        location_name: "Lieu de l'événement",
      },
    },
    event_types: {
      name: "Type d'offre |||| Types d'offres",
      template_hint:
        "Ces modèles s'appliquent aux commandes et réservations de ce type d'offre. Une commande couvrant plusieurs types d'offre utilise le modèle par défaut du système. Si un modèle est laissé vide, le modèle par défaut est utilisé.",
      array_input_fields: {
        description_fields: "Champ de description |||| Champs de description",
      },
      fields: {
        name: "Nom",
        invoice_template: "Modèle de facture",
        invoice_mail_template: "Modèle d'e-mail de facture",
        booking_confirmation_template: "Modèle de confirmation d'e-mail de réservation",
        order_manual_processing: "Traitement des commandes",
      },
      order_manual_processing_hint:
        "Les commandes mêlant lignes manuelles et automatiques sont toujours traitées manuellement.",
      order_manual_processing_choices: {
        inherit: "Utiliser le paramètre général (%{value})",
        manual: "Manuel",
        auto: "Automatique",
      },
      headlines: {
        settings: "Paramètres d'affichage",
        templates: "Modèles",
      },
    },
    external_email_templates: {
      name: "Modèle d'e-mail |||| Modèles d'e-mails",
      fields: {
        scope: "Portée",
        external_id: "ID externe",
        subject: "Objet",
        sender: "Expéditeur par défaut",
        is_default: "Modèle par défaut",
        bcc: "Adresse e-mail CCI",
        language: "Langue",
        parent_template: "Modèle supérieur",
        recipient_role: "Destinataire",
        recipient_contact_info_type: "Type d'adresse",
      },
      helper_texts: {
        recipient_role: "Si la commande n'a pas d'organisation, la personne qui a passé la commande reçoit l'e-mail.",
      },
      headlines: {
        scope_info: "Description des portées",
      },
      array_input_fields: {
        content_blocks: "Blocs de contenu",
        event_blocks: "Blocs d'événements",
      },
    },
    feedback_forms: {
      name: "Formulaire de feedback |||| Formulaires de feedback",
      fields: {
        name: "Nom",
        introduction: "Introduction",
        closing_remark: "Remarque finale",
        questions: "Questions",
      },
      array_input_fields: {
        questions: "Questions",
      },
      actions: {
        add_question: "Ajouter une question",
        add_as_new_question: "Ajouter comme nouvelle question",
        send: "Envoyer le feedback",
        group_questions: "Grouper par questions",
        add_question_group: "Ajouter un groupe de questions",
        add_question_group_template: "Ajouter un modèle de groupe de questions",
        new_question: "Nouvelle question",
        existing_question: "Question existante",
        duplicate: "Dupliquer",
      },
    },
    feedback_form_question_groups: {
      name: "Groupe de questions |||| Groupes de questions",
      fields: {
        name: "Nom",
        description: "Description",
      },
      template: "Modèle de groupe de questions",
      hints: {
        load_from_template:
          "Le groupe de questions sélectionné, y compris les questions, est ajouté au questionnaire de satisfaction ci-dessous. Si les questions figurent déjà dans le questionnaire de satisfaction, elles sont ignorées et ne sont pas reprises.",
      },
    },
    question_select_values: {
      name: "Option de sélection |||| Options de sélection",
      fields: {
        value: "Valeur",
      },
    },
    files: {
      name: "Document |||| Documents",
      fields: {
        file_size: "Taille du fichier",
        variant_urls: "URL des variantes d'image",
        id: "ID",
        data: "Données",
        related_id: "ID liée",
        related_resource: "Ressource liée",
        mime_types: "Types MIME",
        created_by: "Créé par",
        created_at: "Créé le",
        url: "URL",
        description: "Description",
        name: "Nom",
        name_sortable: "Nom",
        original_filename: "Nom de fichier",
        tags: "Mots-clés",
        visible_for_all: "Public",
        visible_for_attendees: "Partagé avec les participants sur le portail",
        visible_for_lecturers: "Partagé avec les enseignants sur le portail",
        visibility: "Libérations",
      },
      actions: {
        open: "Ouvrir le fichier",
      },
      hints: {
        file_not_previewable: "Il n'est pas possible de prévisualiser ce format de fichier.",
      },
    },
    generated_documents: {
      name: "Document généré automatiquement |||| Documents générés automatiquement",
      hints: {
        persist_on_relation:
          "Le document est déposé sur l'enregistrement actuel (%{relationName}) et est visible pour les collaborateurs. Il est possible d'attribuer des autorisations supplémentaires: |||| Les documents sont déposés aux %{relationName} et sont visibles pour les collaborateurs. Il est possible d'attribuer des autorisations supplémentaires:",
      },
    },
    generate_document_tasks: {
      name: "Tâche de génération de documents |||| Tâches de génération de documents",
    },
    integrated_applications: {
      name: "Application liée |||| Applications liées",
      fields: {
        active: "Actif",
        name: "Nom",
      },
      labels: {
        activate: "Activer",
        deactivate: "Désactiver",
        inactive: "Inactif",
        active: "Actif",
        connect: "Connecter",
        disconnect: "Séparer",
        finish_oauth_connect: "Terminer la connexion OAuth",
      },
    },
    interests: {
      name: "Intéressé(e) |||| Intéressés",
      fields: {
        event_name: "Événement",
        user_full_name: "Nom",
        created_at: "Créé",
        user__last_name: "Nom de famille",
      },
      actions: {
        remove: "Supprimer le favori",
      },
    },
    invoices: {
      name: "Facture |||| Factures",
      headlines: {
        covered_items: "Positions facturées",
        related: "Factures associées",
        covered_line_items: "Lignes déjà facturées et gratuites (%{count})",
        preview: "Aperçu",
        details: "Détails",
      },
      fields: {
        title: "Titre",
        first_name: "Prénom",
        last_name: "Nom de famille",
        organization_name: "Nom de l'organisation",
        is_organization: "Est une organisation",
        debit_number: "Numéro de débiteur",
        parent: "Facture d'origine",
        sum_without_tax: "Total net",
        kind: "Type",
        template: "Modèle de facture",
        override_contact_info: "Remplacer les informations de contact",
        price: "Prix",
        name: "Titre",
        download: "Télécharger",
        invoice_number: "Numéro de facture",
        service_period: "Période de prestation",
        generated_at: "Généré",
        created_at: "Date de facturation",
        due_date: "Date d'échéance",
        sent_at: "Envoyé",
        recipient: "Destinataire de la facture",
        payment: "Paiement",
        accounting_transfer_success_at: "Transféré",
        accounting_transfer_error: "Erreur de transmission",
        is_paid: "Payé",
        price_gross: "Brut",
        price_net: "Net",
        credited: "moins les corrections",
        effective: "Montant effectif",
        booking__event__event_base__name: "Titre de l'offre",
        booking__attendee__last_name: "Nom de famille",
        buyer_name: "Acheteur/-euse",
        order__order_number: "Numéro de commande",
        paid_amount: "Montant payé",
        external_accounting_id: "ID de comptabilité",
        recipient_name: "Nom du destinataire",
        reference: "Facture de référence",
        referenced_by: "Référencée par",
      },
      actions: {
        show_booking: "Vers la réservation",
        show_order: "Vers la commande",
        download: "Télécharger la facture",
        set_is_paid: "Marquer comme payé",
        unset_is_paid: "Marquer comme impayé",
        bulk_reversal: "Annuler",
        reverse: "Annuler",
        correct: "Corriger",
        add_line_item: "Ajouter une position",
        drop_line_item: "Supprimer",
        open_in_external_accounting: "Ouvrir dans la comptabilité",
        sync_with_external_accounting: "Synchroniser avec la comptabilité",
        reset_accounting_transfer: "Réinitialiser la transmission",
      },
      kinds: {
        standard: "Standard",
        correction: "Correction",
        reversal: "Annulation",
      },
      hints: {
        unresolved_accounting_lines_title: "Champs comptables manquants",
        unresolved_accounting_lines_hint: "Les champs comptables ne sont pas encore renseignés pour ces événements:",
        accounting_transfer_error_hint: "Une erreur s'est produite lors du transfert:",
        due_on: "Échéance le %{date}",
        pdf_not_generated: "Le document de facture n'a pas encore été généré.",
        reference: "Une facture de cette commande à laquelle le document se réfère.",
        reverse_explanation:
          "Cela annule toute la facture avec un document d'annulation. Cette action est irréversible.",
        correct_explanation: "Ces lignes d'avoir seront créées comme document de correction.",
        reversal_created: "Annulation créée",
        document_generation_failed: "Le document n'a pas pu être généré. Vérifiez le modèle de facture.",
        correction_created: "Correction créée",
        reversal_partially_skipped:
          "Annulation créée ; %{count} facture(s) ont été ignorées car elles ne pouvaient pas être annulées.",
        accounting_transfer_started: "Transfert vers la comptabilité lancé",
        reset_accounting_transfer_success: "Réinitialisation du transfert réussie",
        reset_accounting_transfer_error: "Erreur lors de la réinitialisation de la transmission",
        reset_accounting_transfer_hint:
          "Voulez-vous vraiment annuler le transfert ? Cela entraînera la perte des données comptables et un nouveau transfert pourra être lancé.",
        no_invoice_templates_present: "Avant de créer une facture, il faut enregistrer un modèle de facture (%{kind}).",
        line_item_already_invoiced: "Cette ligne est déjà facturée. N'ajoutez que ce qui est facturé en supplément.",
        line_item_free: "Ligne gratuite : rien à facturer. N'ajoutez que ce qui est facturé en supplément.",
        line_item_not_billed: "Non facturé",
        discarded_after_document_failure:
          "La facture a été supprimée car aucun document n'a pu être généré. |||| Les factures ont été supprimées car aucun document n'a pu être généré.",
        correction_nothing_selected: "Au moins une ligne de facture doit conserver ses lignes d'avoir.",
        bulk_reversal_placeholder:
          "Le caractère de remplacement %{invoiceNumber} est remplacé par le numéro de facture d'origine correspondant lors de la génération de la facture.",
      },
    },
    invoice_tax_amounts: {
      name: "Montant de TVA par taux |||| Montants de TVA par taux",
      fields: {
        tax_rate: "Taux de TVA",
        amount: "Montant de TVA",
      },
    },
    invoice_templates: {
      name: "Modèle de facture |||| Modèles de factures",
      fields: {
        name: "Nom",
        zugferd_tax_exemption_reason_text: "Motif d'exonération fiscale",
        zugferd_payment_terms_description: "Conditions de paiement",
        zugferd_payment_means_code_type: "Code du moyen de paiement",
        is_default: "Default Template",
      },
      hints: {
        zugferd_fields: "Champs ZUGFeRD",
      },
    },
    lecturers: {
      name: "Enseignant*e |||| Enseignants",
      fields: userFields,
      is_archived: "Cet*te enseignant*e est archivé*e",
      actions: {
        enroll_to_moodle_courses: "Inscrire l'enseignant*e aux cours Moodle",
      },
    },
    notes: {
      name: "Note |||| Notes",
      fields: {
        high_priority: "Épinglé",
        text: "Texte",
      },
      actions: {
        pin: "Épingler",
        unpin: "Détacher",
        delete: "Supprimer",
        create: "Créer une note",
        update: "Mettre à jour la note",
      },
    },
    contact_infos: {
      name: "Information de contact |||| Informations de contact",
      fields: userFields.contact_info,
    },
    moodle_courses: {
      name: "Cours Moodle |||| Cours Moodle",
      fields: {
        id_number: "Numéro de cours",
        name: "Nom du cours",
        category: "Catégorie",
        short_name: "Nom court du cours",
        start_date: "Début du cours",
        end_date: "Fin du cours",
      },
      actions: {
        connect: "Associer à un cours existant",
        delete: "Supprimer le cours également sur Moodle",
        create_new: "Créer et associer un nouveau cours",
        enroll_remaining_attendees:
          "%{numberOfAttendees} autre participant avec compte Moodle inscrire |||| %{numberOfAttendees} autres participants avec compte Moodle inscrire",
        enroll_all_valid_attendees: "Inscrire les participants avec compte Moodle au cours",
      },
      moodle_course_has_no_users_enrolled: "Aucun participant n'a encore été inscrit à ce cours.",
      moodle_course_number_of_enrolled_bookings: "%{numberEnrollments} de %{numberBookings} participants inscrits",
      connected_lecturers: "Conférenciers associés",
    },
    moodle_enrollments: {
      name: "Inscription Moodle |||| Inscriptions Moodle",
      history_change: "pour %{userName} dans le cours %{courseName}",
    },
    moodle_users: {
      name: "Compte Moodle |||| Comptes Moodle",
      is_connected_with_moodle: "Est connecté avec un",
      actions: {
        delete: "Supprimer le compte également sur Moodle",
      },
      moodle_number_of_enrollments_info:
        "%{smart_count} %{resource} sera inscrit aux cours Moodle sélectionnés |||| %{smart_count} %{resource} seront inscrits aux cours Moodle sélectionnés",
    },
    o_auth_apps: {
      name: "Application OAuth |||| Applications OAuth",
      fields: {
        is_superapplication: "App Admin",
        client_type: "Type de client",
        client_id: "ID du client",
        client_secret: "Secret du client",
        authorization_grant_type: "Type de subvention d'autorisation",
        auth_groups: "Groupes d'autorisation",
        redirect_uris: "URIs de redirection",
        post_logout_redirect_uris: "URIs de Redirection Post-déconnexion",
        skip_authorization: "Sauter l'autorisation",
        pkce_required: "PKCE requis",
        algorithm: "Algorithme",
        application_permissions: "Autorisations",
      },
      helper_texts: {
        client_secret_create: "Laisser vide pour générer automatiquement un secret.",
        client_secret_edit: "Masqué pour des raisons de sécurité. Laisser vide pour conserver le secret actuel.",
      },
    },
    occupancy: {
      name: "Occupation",
      fields: {
        unprocessed_order_items: "poste de commande non traité |||| postes de commande non traités",
        held_order_seats: "place réservée (commande) |||| places réservées (commandes)",
        attendees_max: "de max. %{max} participants",
        attendees_min_reached: "Nombre minimum %{min} atteint",
        attendees_min: "jusqu'au nombre minimum %{min}",
        waiting: "en attente",
        vacant_bookings: "place disponible |||| places disponibles",
        vacant_waiting_hint: "%{count} sur liste d'attente",
      },
    },
    organizations: {
      name: "Organisation |||| Organisations",
      actions: {
        quick_create: "Créer une nouvelle organisation",
      },
      fields: {
        id: "ID",
        invoice_contact_info: "Facturation",
        invoice_dispatch_contact_info: "Expédition de facture",
        name: "Nom",
        tags: "Étiquettes",
        debit_number: "Numéro de débiteur",
        value_added_tax_id: "Numéro d'identification TVA",
        trade_register_number: "Numéro de registre du commerce",
        fiscal_number: "Numéro fiscal",
        created_at: "Créé le",
      },
    },

    organization_memberships: {
      name: "Appartenance à l'organisation |||| Appartenances aux organisations",
    },

    organization_users: {
      name: "Personne |||| Personnes",
      labels: {
        no_members: "Aucune personne n'est encore associée à cette organisation.",
      },
      fields: {
        organization: "Organisation",
        user: "Personne",
        permissions: "Autorisations",
        can_edit_organization: "Peut modifier l'organisation",
        can_enroll: "Peut passer des commandes",
        can_manage_users: "Peut gérer les personnes",
        create_login: "Créer un accès au portail",
        created_at: "Créé le",
      },
      hints: {
        create_login: "La personne reçoit un e-mail pour configurer son accès.",
      },
      actions: {
        disconnect: "Supprimer la liaison",
        add_member: "Ajouter une personne",
        select_existing_organization: "Organisation existante",
        create_new_organization: "Nouvelle organisation",
      },
    },
    price_types: {
      name: "Type de prix |||| Types de prix",
      fields: {
        name: "Nom",
        short_name: "Abréviation",
      },
      is_archived: "Ce type de prix est archivé",
      for_free: "Gratuit",
    },
    price_positions: {
      name: "Position |||| Positions",
      default_first_position_name: "Participation",
      fields: {
        sales_tax: "TVA",
        attendee_name: "Participant*e",
        event_name: "Événement",
        event_id_number: "Numéro de l'événement",
        amount: "Montant",
        name: "Nom",
        quantity: "Quantité",
        inventory_account: "Compte d'inventaire",
        tax_rate: "TVA",
      },
    },
    prices: {
      name: "Prix |||| Prix",
      fields: {
        amount: "Montant",
        cached_amount: "Montant",
        positions: "Positions",
        price_type: "Type de prix",
        price_type_name: "Nom du type de prix",
        valid_from: "Valable à partir de",
        valid_until: "Valable jusqu'à",
      },
      labels: {
        amount: "Montant",
        invoiced_amount: "Montant facturé",
        paid_amount: "Statut du paiement",
        fully_invoiced: "Entièrement facturé",
      },
      tooltips: {
        amount:
          "Le montant dû et son type de prix. Zéro signifie « gratuit », sauf lorsque le montant n'est nul que parce que toutes les positions ont été annulées : le montant est alors affiché.",
        invoiced_amount:
          "Dès qu'une partie du montant est facturée, la somme facturée s'affiche devant : en gris tant qu'elle reste inférieure au montant, en orange si elle le dépasse. Une fois tout facturé, le montant passe au vert.",
        paid_amount:
          "Une double coche verte signifie que la totalité du montant est payée, une seule coche que tout ce qui a été facturé jusqu'ici est payé. Un paiement partiel s'affiche sous forme de montant. Aucune coche signifie que rien n'a encore été payé.",
      },
    },
    partners: {
      name: "Partenaire de coopération",
      fields: {
        logo_path: "Chemin du logo",
        id: "ID",
        name: "Nom",
        url: "URL",
        logo: "Logo",
      },
    },
    qualifications: {
      name: "Qualification |||| Qualifications",
    },
    questions: {
      name: "Question |||| Questions",
      fields: {
        type: "Type de question",
      },
      types: {
        RATING: "Évaluation",
        SINGLE_CHOICE: "Choix unique",
        MULTIPLE_CHOICE: "Choix multiple",
        FREE_TEXT: "Texte libre",
      },
    },
    report: {
      name: "Évaluation",
    },
    response_forms: {
      name: "Évaluation des retours",
      filters: {
        feedback_form: "Formulaire",
        event: "Événement",
        lecturers: "Enseignants",
        event_base: "Offre",
        responsible_person: "Personne responsable",
        question: "Question",
        date_to: "Créé jusqu'au",
        date_from: "Créé par",
        question_type: "Type de question",
      },
    },
    responses: {
      name: "Réponse |||| Réponses",
    },
    responsibilities: {
      name: "Responsabilité |||| Responsabilités",
    },
    responsibility_types: {
      name: "Responsabilité |||| Responsabilités",
      fields: {
        event_types: "Types d'offre",
      },
    },
    settings: {
      name: "Général",
      fields: {
        value: "Valeur",
        key: "Paramètre",
      },
    },
    webhook_subscriptions: {
      name: "Webhook Subscription |||| Webhook Subscriptions",
    },
    subscriptions: {
      name: "Webhook |||| Webhooks",
      fields: {
        name: "Nom",
        is_active: "Actif",
        endpoint_url: "URL de point de terminaison",
        event_types: "Événements",
        secret: "Secret",
      },
      helper_texts: {
        secret_edit: "Masqué pour des raisons de sécurité. Laisser vide pour conserver le secret actuel.",
      },
    },
    tags: {
      name: "Mot-clé |||| Mots-clés",
      fields: {
        name: "Nom",
      },
    },
    tax_rates: {
      name: "Taux de TVA |||| Taux de TVA",
      fields: {
        amount: "Pourcentage",
        untdid_category: "Catégorie UNTDID 5305",
        is_default: "Utiliser comme préselection",
      },
    },
    users: {
      name: "Personne |||| Personnes",
      fields: userFields,
      is_archived: "La personne est archivée",
      actions: {
        quick_create: "Créer une nouvelle personne",
        add_invoice_contact_info: "Ajouter une adresse de facturation différente",
        connect_moodle_account: "Lier le compte Moodle |||| Lier les comptes Moodle",
        disconnect_moodle_user: "Dissocier le compte Moodle",
        unenroll_moodle_enrollment: "Se désinscrire du cours Moodle",
        suspend_moodle_enrollment: "Définir comme inactif",
        unsuspend_moodle_enrollment: "Définir comme actif",
        add_login: "Ajouter une connexion |||| Ajouter des connexions",
        remove_login: "Supprimer la connexion",
        change_email: "Changer l'email",
        add_attendee_role: "Ajouter le rôle de participant |||| Ajouter des rôles de participant",
        add_lecturer_role: "Ajouter le rôle d'intervenant |||| Ajouter des rôles d'intervenant",
        remove_attendee_role: "Retirer le rôle de participant",
        remove_lecturer_role: "Retirer le rôle d'intervenant",
        create_interest: "Ajouter un intéressé*e",
      },
      login: {
        name: "Nom",
        email: "Email",
        comment: "Remarque",
      },
      gender: {
        male: "Masculin",
        female: "Féminin",
        non_binary: "Non-binaire",
      },
    },
    user_moodle_users: {
      name: "Liaison de compte Moodle |||| Liaisons de compte Moodle",
    },
    staff_members: {
      name: "Employé(e) |||| Employés",
      is_archived: "Cet employé est archivé",
      fields: {
        ...userFields,
        roles: "Groupes d'autorisations",
        is_2fa_required: "Authentification à deux facteurs requise",
        color: "Couleur",
        email_senders: "Expéditeurs d'emails attribués",
      },
    },
    two_factor: {
      name: "Authentification à deux facteurs",
      actions: {
        reset_2fa: "Réinitialiser 2FA",
      },
      confirm: "Vraiment réinitialiser l'authentification à deux facteurs?",
      success: "Authentification à deux facteurs réinitialisée avec succès",
      error: "Impossible de réinitialiser l'authentification à deux facteurs.",
    },
    custom_field_content_types: {
      name: customFieldContentTypeName,
      content_types: {
        organization_users: "Personnes de l'organisation",
      },
      fields: {
        resource: "Ressource",
        slug: "Identifiant",
        custom_fields: customFieldContentTypeName,
      },
    },
    custom_fields: {
      name: "Champ avancé (données maîtres) |||| Champs avancés (données maîtres)",
      array_input_fields: {
        custom_fields: "Champ |||| Champs",
      },
      actions: {
        add_field: "Ajouter un champ",
        add_custom_field_section: "Ajouter une zone",
      },
      notification: {
        slug_not_unique: "Le label / l'identifiant ne sont pas uniques.",
      },
      headlines: {
        attendee_fields: "Champs des participants",
        booking_fields: "Champs de réservation",
      },
      fields: {
        label: "Étiquette",
        slug: "Identifiant",
        field_type: "Type de champ",
        data_type: "Type de données",
        width: "Largeur",
        show_per_default: "Toujours afficher",
        soft_required: "Requis",
        allowed_for_enrollment: "Autoriser pour les inscriptions",
        allowed_for_order: "Autoriser pour les commandes",
        allow_multiple_select: "Autoriser la sélection multiple",
        editable_by_user: "Modifiable dans le portail",
        editable_by_buyer: "Renseignable à la commande",
        visible_for_attendees: "Partagé avec les participants sur le portail",
        visible_for_lecturers: "Partagé avec les enseignants sur le portail",
        relation_content_type: "Type de contenu",
        field_types: {
          TEXT: "Texte",
          TEXTAREA: "Zone de texte",
          RICHTEXT: "Éditeur de texte riche",
          NUMBER: "Nombre",
          DATE: "Date",
          BOOLEAN: "Oui / Non",
          SELECT: "Sélection",
          RELATION: "Relation",
          RELATION_MANY: "Relation (multiple)",
        },
        field_info: {
          TEXT: "champ texte sur une ligne",
          TEXTAREA: "champ texte sur plusieurs lignes",
          RICHTEXT: "Texte enrichi",
          NUMBER: "champ numérique",
          DATE: "champ de date",
          BOOLEAN: "champ Oui / Non",
          SELECT: "champ de sélection",
          RELATION: "Relation",
          RELATION_MANY: "Relation (multiple)",
        },
      },
    },
    todo_lists: {
      name: "Liste de tâches |||| Listes de tâches",
      fields: {
        name: "Nom",
      },
      array_input_fields: {
        todos: "Tâches",
      },
      actions: {
        add: "Créer une liste",
        add_template_list: "Charger le modèle de liste",
        edit: "Modifier la liste",
      },
    },
    todos: {
      name: "Tâche |||| Tâches",
      actions: {
        add: "Ajouter une tâche",
        edit: "Modifier la tâche",
        showDone: "Afficher les tâches récemment terminées",
        hideDone: "Masquer les tâches récemment terminées",
      },
      fields: {
        assignee: "Personne assignée",
        due_date: "Date d'échéance",
        text: "Texte",
        is_done: "Terminé",
        event__first_day: "Événement",
      },
      filters: {
        due_date__lte: "Dû jusqu'à",
      },
      own_todos: "Mes tâches",
      no_todos: "Vous n'avez actuellement aucune tâche ouverte.",
      no_done_todos: "Vous n'avez jusqu'à présent aucune tâche terminée.",
      hints: {
        reorder_error: "Le nouvel ordre n'a pas pu être enregistré.",
      },
    },
    user_list_configurations: {
      actions: {
        rename: "Renommer",
        manage_filters: "Afficher les filtres",
        save_as_new: "Enregistrer comme nouvelle vue",
        save_view: "Enregistrer la vue",
        save_changes: "Enregistrer les modifications",
      },
      hints: {
        error_loading_configuration: "Erreur lors du chargement des vues personnalisées",
      },
    },
    user_lists: {
      name: "Liste |||| Listes",
      fields: {
        name: "Nom",
        is_public: "Public",
        brevo_id: "ID de Liste Brevo",
        consent_type: "Type de consentement",
        users: "Personnes",
        user_list: "Liste",
        description: "Description",
        brevo_list_name: "Nom de la Liste Brevo",
        brevo_folder: "Dossier Brevo",
        consent_given: "Consentement déjà donné",
        no_consent: "Aucun consentement",
        consent_method: "Consentements",
        trigger_confirmation: "Déclencher le processus de consentement (Double-Opt-In)",
      },
      actions: {
        add_persons: "Ajouter des personnes",
        remove_from_list: "Retirer de la liste",
        sync_to_brevo: "Synchroniser avec Brevo",
        import_from_brevo: "Importer les contacts de Brevo",
        connect_existing_brevo_list: "Connecter une liste Brevo existante",
        connect_new_brevo_list: "Créer une nouvelle liste Brevo",
        sync_list: "Synchroniser la liste",
        save_and_sync: "Enregistrer et synchroniser",
      },
      consent_dialog: {
        add_title: "Consentement requis",
        add_message: "Voulez-vous accepter ce consentement pour être ajouté à la liste ?",
        accept_consent: "Accepter et ajouter à la liste",
        remove_title: "Retirer le consentement",
        remove_message:
          "Voulez-vous également retirer votre consentement ? Vous serez retiré de la liste dans tous les cas.",
        keep_consent: "Conserver le consentement",
        remove_consent: "Retirer le consentement",
      },
      hints: {
        brevo_sync_info:
          "Associez une liste Brevo - les personnes sont synchronisées automatiquement. Utilisez le bouton 'Synchroniser la liste' pour appliquer manuellement les modifications. Seules les nouvelles données sont envoyées à Brevo, rien n'est supprimé.",
        brevo_migrate_info:
          "Les contacts de la liste Brevo liée seront importés dans EDM. Si un utilisateur avec le même e-mail de connexion est trouvé dans EDM, il sera utilisé. Sinon, un nouveau 'contact' sera créé dans EDM.",
        unsubscribe_success: "Vous avez été désinscrit avec succès de la liste.",
        unsubscribe_failure: "La désinscription de la liste a échoué.",
      },
      sections: {
        subscribable: "Listes abonnables",
      },
      filters: {
        consent_status: "A donné son consentement",
      },
      notifications: {
        successfully_added_users: "Personne ajoutée à la liste |||| Personnes ajoutées à la liste",
        successfully_updated_list: "Liste mise à jour avec succès",
      },
    },

    user_list_data: {
      name: "Liste Abonnée |||| Listes Abonnées",
      fields: {
        combined_first_name: "Prénom",
        combined_last_name: "Nom de famille",
        created_at: "Date de création",
        combined_email: "Email",
        is_synced: "Synchronisé",
        user__first_name: "Prénom",
        user__last_name: "Nom de famille",
        user__contact_infos__email: "E-mail",
      },
      filters: {
        type: "Type",
        contacts: "Contacts",
        users: "Personnes",
      },
      actions: {
        remove_consent: "Supprimer également le consentement",
      },
      hints: {
        remove_confirm:
          "Voulez-vous vraiment supprimer cette personne de la liste ? Remarque : si une liste Brevo est associée, la personne sera également supprimée de la liste dans Brevo.",
      },
    },
  },
  page_sections: {
    actions: "Actions",
    orders: "Commandes",
    relations: "Affectations",
    sales: "Rapports",
    bookings: "Réservations",
    bookings_files: "Documents de réservation",
    child_event_bases: "Sous-offres",
    contact_infos: "Informations de contact",
    core_data: "Données principales",
    description: "Description",
    direct_bookings: "Réservations directes",
    event_groups: "Groupes d'événements",
    events: "Événements",
    extended: "Étendu",
    files: "Documents",
    general: "Vue d'ensemble",
    groups: "Groupes",
    high_priority_notes: "Notes importantes",
    history: "Historique",
    image: "Image",
    interested_users: "Intéressés",
    waiting_users: "Liste d'attente",
    potential_attendees: "Participants potentiels",
    interests: "Intérêts",
    login: "Connexion",
    moodle: "Moodle",
    notes: "Notes",
    password_reset: "Réinitialiser le mot de passe",
    prices: "Prix",
    related_notes: "Notes associées",
    settings: "Paramètres",
    profile: "Profil",
    feedback_form: "Formulaires de feedback",
    questions: "Questions",
    question_groups: "Modèles de groupes de questions",
    feedback: "Retour d'information",
    attendance: "Présence",
    activity: "Activité",
    twofa: "Authentification à deux facteurs",
    password_change: "Gestion du mot de passe",
    visit_website: "Vers le site web",
    language_versions: "Variantes linguistiques",
    attendees: "Participant*e |||| Participant*es",
    emails: "E-mails",
    persons: "Personnes",
    organizations: "Organisations",
  },
  menu_sections: {
    export: "Exporter",
    bookings: "Réservations",
    communication: "Communication",
    participants: "Participants",
    roles_access: "Rôles et accès",
    moodle: "Moodle",
    manage: "Gérer",
  },
  password_reset: {
    success: "Le nouveau mot de passe a été défini",
    failure: "Échec de la définition du mot de passe. Veuillez réessayer.",
    submit: "Définir un nouveau mot de passe",
    passwordsUnequal: "ne correspond pas au mot de passe",
    passwordEmpty: "Il manque un mot de passe",
    fields: {
      password: "Mot de passe",
      passwordConfirm: "Confirmation du mot de passe",
    },
  },
  filters: {
    attendance_event_type: "Type de participation",
    attendance_category: "Catégorie",
    attendance_event_base: "Offre",
    attendance_tags: "Mot-clé",
    bookings: {
      attendee_state: "État (Communication)",
      attendee_state_invoice: "État (Facturation)",
      first_event_day_from: "Événement de",
      first_event_day_to: "Événement jusqu'à",
      created_at_from: "Réservé de",
      created_at_to: "Réservé jusqu'à",
      group_bookings: "Réservations de groupe",
      booking_number: "Numéro de réservation",
      event_in: "Événements",
      context: "Environnement",
      order_status: "Statut de commande",
      order_organization: "Organisation (commande)",
    },
    categories: {
      has_parent_category: "A catégorie parente",
      parent_category_isnull: "Est catégorie parente",
    },
    context: "Environnement",
    current: "En cours",
    created_at_from: "Créé de",
    created_at_to: "Créé jusqu'à",
    custom_field_date_from: "%{label} à partir du",
    custom_field_date_to: "%{label} jusqu'au",
    events: {
      first_day_from: "Date de début",
      first_day_to: "Date de fin",
      number_or_event_base_title: "Numéro / Titre de l'offre",
      fully_booked: "Complet",
      modules: "Modules",
      hide_modules: "Sans modules",
      modules_only: "Modules seulement",
    },
    groups_only: "Groupes seulement",
    have_attended: "A participé",
    history: {
      from: "De",
      to: "À",
      changed_by: "Modifié par",
      resource: "Type",
    },
    invoices: {
      is_paid: "Est payé",
    },
    is_archived: "Archivé",
    is_bookable: "Réservable",
    is_public: "Public",
    name: "Nom",
    search: "Recherche",
    solo_event_bases_only: "Offres individuelles seulement",
    solo_events_only: "Événements individuels seulement",
    users: userAndEnrollmentFilters,
    upcoming: "À venir",
    user_list: "Liste",
    waitinglist_events: "Événements de liste d'attente",
    valid_booking_event: "Événements réservés",
    consent_type: "Type de consentement",
    completion_status: "Statut d'envoi",
    incomplete_email_jobs: "Incomplets uniquement",
    complete_email_jobs: "Complets uniquement",
    organizations: "Organisations",
  },
  hints: {
    event_date_details_inherited: "Les informations grisées proviennent des données de base de l'événement.",
    all_price_types_taken:
      "Un prix a été créé pour chaque type de prix. Pour pouvoir ajouter plus de prix, un type de prix supplémentaire doit d'abord être créé.",
    user_without_email_present:
      "L'enregistrement sélectionné nécessite une adresse e-mail. |||| Tous les enregistrements sélectionnés nécessitent une adresse e-mail.",
    accounting_invoice_already_present: "Une facture avec ce numéro a déjà été transmise.",
    child_of: "contenu dans",
    custom_field_models_present: "Il existe déjà %{resource} où %{field} est défini.",
    delete_invoice_with_children:
      "La suppression d'une facture n'est possible que s'il n'y a pas d'autres factures y associées.",
    disabled_add_dates: "Les dates d'un groupe d'événements sont générées à partir des dates des événements associés.",
    event_bulk_update:
      "Les champs remplis sont écrasés sur tous les événements sélectionnés. Les champs vides restent inchangés et les événements subordonnés ne sont pas modifiés.",
    unchanged: "Inchangé",
    event_status_label: "Statut : %{status}",
    files_are_private:
      "Ce fichier est privé et ne peut être récupéré qu'à partir d'ici. |||| Ces fichiers sont privés et ne peuvent être récupérés qu'à partir d'ici.",
    files_are_public:
      "Ce fichier est public et peut être vu par tous ceux qui ont le lien. |||| Ces fichiers sont publics et peuvent être vus par tous ceux qui ont le lien.",
    group_bookings_selected: "Des réservations de groupe sont sélectionnées",
    invoice_override_prices:
      "Normalement, pour créer la facture, le prix actuel de la réservation sélectionnée est utilisé |||| Normalement, pour créer les factures, les prix actuels des réservations sélectionnées sont utilisés",
    is_event_group: "Groupe d'événements",
    is_event_base_group: "Groupe d'offres",
    is_group: "Groupe",
    is_group_booking: "Réservation de groupe",
    link_to_event_base: "Vers la page d'offre",
    external_sender_sync_hint:
      "Veuillez indiquer uniquement si l'expéditeur existe déjà chez Brevo et ne doit pas être créé à nouveau",
    sender_delete_message: "Êtes-vous sûr de vouloir supprimer cet expéditeur d'e-mail ?",
    login: {
      all_users_have_login: "%{resource} a déjà un identifiant |||| Tous les %{resource} ont déjà un identifiant",
      created: "Identifiant créé",
      email_absent: "Aucun e-mail d'identification présent",
      email_exists:
        "Si l'e-mail d'identification existe déjà, les participants peuvent être fusionnés avec la fonction \"Fusionner\".",
      not_all_users_have_login:
        "%{resource} n'a pas encore d'identifiant |||| Pas tous les %{resource} ont un identifiant",
      present: "Identifiant présent",
      will_be_created: "Identifiant sera créé",
      email_empty: "L'identifiant ne peut être créé qu'avec un e-mail valide",
      consent_info:
        "En créant les identifiants, les personnes donnent automatiquement leur consentement à l'utilisation du portail des participants/formateurs. Aucun processus de double opt-in n'a lieu. Veuillez vous assurer que cela est souhaité.",
      remove_confirm:
        "Supprime la connexion de %{name}. La fiche de la personne est conservée ; seul son accès au portail des participants/formateurs est supprimé.",
    },
    role: {
      remove_attendee_confirm:
        "Retire le rôle de participant à %{name}. La fiche de la personne est conservée ; seules les données propres au participant (rôle d'audience, numéro de débiteur, champs personnalisés) sont supprimées.",
      remove_lecturer_confirm:
        "Retire le rôle d'intervenant à %{name}. La fiche de la personne est conservée ; seules les données propres à l'intervenant (honoraires, qualifications, catégories, champs personnalisés) sont supprimées.",
    },
    moodle: {
      all_connected: "%{resource} est déjà connecté |||| Tous les %{resource} sont déjà connectés",
      connect_error: "Échec de la connexion",
      connected: "est déjà connecté",
      course_enrolled_users_count: "%{enrolledUsersCount} sur %{bookingsCount} participants inscrits",
      course_without_enrollments: "Aucun participant n'a encore été inscrit à ce cours.",
      not_all_users_have_account: "Pas tous les %{resource} ont un compte Moodle",
      no_linked_courses: "Aucun cours Moodle n'a été associé à cet événement jusqu'à présent",
      present: "sera associé à un compte Moodle déjà existant (%{info})",
      will_be_created: "sera créé dans Moodle",
      has_moodle_account: "Compte Moodle associé",
    },
    payment: {
      self_managed: "Paiement géré par le participant lui-même",
    },
    event_type_necessary_for_resource: "Le type d'offre doit être défini avant que %{resource} puisse être créé.",
    no_prices_present: "Aucun tarif n'est disponible pour cet événement.",
    non_bookable_group_child: "Événement non réservable individuellement",
    update_main_contact_info: "Adopter l'adresse de communication de l'inscription pour le participant",
    update_invoice_contact_info: "Adopter l'adresse de facturation de l'inscription pour le participant",
    update_invoice_dispatch_contact_info:
      "Adopter l'adresse d'envoi de la facture de l'inscription pour le participant",
    all_users_have_login: "Tous les %{resource} ont un identifiant",
    login_email_exists:
      "Si l'e-mail de connexion existe déjà, les participants peuvent être fusionnés avec la fonction Fusionner.",
    login_email_absent: "Aucun e-mail de connexion disponible",
    sub_record_fetch_error:
      "%{resource} pour %{parentResource} n'a pas pu être chargé. |||| %{resource} pour %{parentResource} n'ont pas pu être chargés.",
    report: {
      data_info_headline: "Base de données",
      data_info_content:
        "Les données sous-jacentes sont filtrées selon différents statuts d'événements en fonction de la période sélectionnée. Pour les périodes passées, les événements (réservations) avec le statut 'GO' et 'Terminé' sont utilisés. En revanche, pour les périodes futures, les événements (réservations) avec le statut 'Offert' et 'GO' sont utilisés.",
      data_info_headline_bookings: "Réservations",
      data_info_content_bookings:
        "La prise en compte d'une réservation pour la période sélectionnée dépend toujours de la date de début de l'événement, la date de réservation elle-même ne joue aucun rôle.",
    },
    bulk_selection_limit_exceeded:
      "Avertissement : Plus de 1000 entrées sélectionnées. Cela peut entraîner des erreurs lors du traitement en masse.",
    similar_attendee_already_exists:
      "Il existe déjà des réservations pour cet événement avec des données similaires pour les personnes suivantes: %{names}. Veuillez vous assurer qu'il ne s'agit pas d'une double réservation involontaire.",
    permission_denied_info:
      "Vous avez effectué une action pour laquelle vous n'avez pas les autorisations requises. Si vous avez besoin d'autorisations supplémentaires, veuillez contacter votre administrateur.",
    current_user_roles: "Vos groupes d'autorisations actuels",
    custom_field_select_already_used:
      "La valeur pour ce champ est déjà enregistrée pour %{count} %{resource}. Souhaitez-vous tout de même modifier la sélection ? Les anciennes valeurs resteront inchangées et ne seront pas mises à jour.",
    feedback_module_of: "Module de retour d'information de",
    feedback_not_found_headline: "Aucun formulaire de retour approprié n'a été trouvé pour ce lien",
    feedback_not_found_info:
      "Veuillez vérifier si le lien est correct. Il est possible que la validité du lien ait expiré.",
    copied_to_clipboard: "Copié dans le presse-papier.",
    custom_field_slug_already_exists_elswhere:
      "Ce slug existe déjà pour %{resource}. La duplication peut entraîner l'intégration des données avec ce slug tant pour la réservation que pour le(s) participant(s) lors de l'inscription. Si ce n'est pas souhaité, un autre slug doit être utilisé.",
    enrollment_already_approved: "Cette inscription a déjà été traitée.",
    enrollment_not_found_headline: "Aucune inscription appropriée n'a pu être trouvée pour ce lien",
    error_info:
      "Malheureusement, une erreur est survenue lors du traitement de votre demande. Ceci indique généralement un problème technique au sein de l'EDM. Si l'erreur persiste, veuillez contacter notre support : ",
    not_found_info:
      "Malheureusement, la page que vous avez demandée n'a pas pu être trouvée. Veuillez vérifier l'URL ou contacter notre support en cas de doute : ",
    only_canceled_bookings_can_be_archived: "Seules les réservations annulées peuvent être archivées.",
    add_lecturers_to_event_children: "En outre, l'enseignant* peut attribuer des cours à ces sous-cours:",
    change_event_base_with_child_or_parent:
      "Cet événement fait partie d'un groupe d'événements. Veuillez noter que seule l'offre de l'événement actuel sera modifiée. Les événements supérieurs ou subordonnés doivent être traités séparément.",
    sender_delete_external: "Supprimer également du service de messagerie externe (Brevo)",
  },
  validations: {
    url: "L'URL n'est pas valide (doit commencer par http:// ou https://)",
    slug_chars: "seules lettres, chiffres et - valides",
    registration_begin_after_deadline:
      "La date de début d'inscription doit être antérieure ou égale à la date limite d'inscription",
    registration_deadline_before_begin:
      "La date limite d'inscription doit être postérieure ou égale à la date de début d'inscription",
    first_day_after_last_day: "Le premier jour doit être antérieur ou égal au dernier jour",
    last_day_before_first_day: "Le dernier jour doit être postérieur ou égal au premier jour",
    attendees_min_greater_than_max:
      "Le nombre minimum de participants doit être inférieur ou égal au nombre maximum de participants",
    attendees_max_less_than_min:
      "Le nombre maximum de participants doit être supérieur ou égal au nombre minimum de participants",
    start_time_after_end_time: "L'heure de début doit être antérieure ou égale à l'heure de fin",
    end_time_before_start_time: "L'heure de fin doit être postérieure ou égale à l'heure de début",
  },
  confirmations: {
    moodle: {
      disonnect_user: "Dissocier %{name} (%{email}) de Moodle?",
      connect_user_create: "Créer un compte pour %{name} (%{email}) sur Moodle?",
      connect_user_with_existing:
        "Un compte avec l'adresse e-mail %{email} est déjà créé sur Moodle. Souhaitez-vous quand même le lier?",
      unenroll_moodle_enrollments:
        "Faut-il désinscrire %{moodleUser} du cours %{courseName}? |||| Désinscrire les participants sélectionnés du cours %{courseName}?",
      suspend_moodle_enrollments:
        "Faut-il désactiver %{moodleUser} dans le cours %{courseName}? |||| Les personnes sélectionnées doivent-elles être définies comme inactives dans le cours %{courseName}?",
      unsuspend_moodle_enrollments:
        "Faut-il activer %{moodleUser} dans le cours %{courseName}? |||| Les personnes sélectionnées doivent-elles être définies comme actives dans le cours %{courseName}?",
      disonnect_course: "Dissocier %{name} de Moodle?",
    },
    event_title: "Champs recommandés pour l'év��nement non remplis",
    event_text:
      "Tous les champs recommandés pour cet événement n'ont pas été remplis. Cela peut entraîner une présentation incomplète de l'événement sur le site Web. Les champs recommandés suivants n'ont pas été remplis:",
    event_fields: "Champs de l'événement:",
    event_base_change_bookings_present: "Des réservations sont présentes",
    event_base_change_explanation:
      "Modifier l'offre peut changer la description de cet événement. Voulez-vous quand même modifier l'offre pour cet événement?",
    event_base_fields: "Champs d'offre:",
    event_save_anyway: "Publier quand même",
    event_save_draft: "Enregistrer comme brouillon",
    event_base_save_anyway: "Enregistrer quand même",
    event_base_failed_soft_validation_title: "Champs recommandés pour l'offre non remplis",
    event_base_failed_soft_validation_text:
      "Tous les champs recommandés pour cette offre n'ont pas été remplis. Cela peut entraîner une présentation incomplète sur le site Web. Les champs recommandés suivants n'ont pas été remplis:",
    delete_invoice:
      "Veuillez noter qu'en cliquant sur 'Confirmer', la facture sélectionnée sera définitivement supprimée. Cela peut causer des problèmes comptables et/ou fiscaux si la facture est déjà en circulation.",
    delete_custom_field:
      "Voulez-vous vraiment supprimer ce champ ? Toutes les données éventuellement enregistrées seront également supprimées.",
    delete_custom_field_section:
      "Voulez-vous vraiment supprimer cette section ? Tous les champs qu'elle contient ainsi que les données éventuellement enregistrées seront également supprimés.",
    delete_following_custom_fields: "Les champs suivants (y compris les données enregistrées) seront supprimés :",
    delete_custom_field_with_data:
      "Un enregistrement existe où %{label} est défini. |||| %{smart_count} enregistrements existent où %{label} est défini.",
    edit_invoice:
      "Veuillez noter que vous modifiez une facture existante. Cela peut causer des problèmes comptables et/ou fiscaux si la facture est déjà en circulation.",
    failed_soft_validation_title: "Champs recommandés non remplis",
    failed_soft_validation_text:
      "Tous les champs recommandés pour cet enregistrement n'ont pas été remplis. Les champs recommandés suivants manquent:",
    slug_changed_title: "Identifiant modifié",
    slug_changed_text:
      "Les descriptions existantes sont liées au champ de description par son identifiant. Faut-il transférer les descriptions déjà saisies pour ce type d'offre vers le nouvel identifiant? Sinon, elles perdent leur lien.",
    slug_changed_move_descriptions: "Transférer les descriptions",
    slug_changed_keep_descriptions: "Enregistrer uniquement le champ",

    non_template_descriptions_present_title: "Descriptions non valides",
    non_template_descriptions_present_text:
      "%{smartCountDescriptions} ne sont plus compatibles avec les champs de description du nouveau type d'offre.",
    remove_from_event_group: "Souhaitez-vous vraiment supprimer cet événement du groupe d'événements?",
    remove_from_event_base_group: "Souhaitez-vous vraiment supprimer cette offre du groupe d'offres?",
    remove_lecturer_from_event: "Souhaitez-vous vraiment retirer cet enseignant de l'événement?",
    event_base_name_already_present: "Titre de l'offre déjà présent",
    event_base_name_already_present_explanation:
      "Le titre de l'offre est déjà présent en dehors d'un groupe. Par conséquent, cette offre ne peut pas être retirée du groupe. Veuillez renommer une des offres d'abord.",
    group_mark_as_attended:
      "Étant donné qu'il s'agit de réservations d'un groupe d'événements, cette action concerne toutes les sous-événements. Les participants sélectionnés seront marqués comme 'a participé' dans tous les sous-événements.",
    group_mark_as_unattended:
      "Étant donné qu'il s'agit de réservations d'un groupe d'événements, cette action concerne toutes les sous-événements. Les participants sélectionnés seront marqués comme 'n'a pas participé' dans tous les sous-événements.",
    add_as_interests: "Souhaitez-vous ajouter les réservations sélectionnées en tant qu'Intéressé?",
    alter_bookings:
      "Les participant(e)s sélectionné(e)s seront inscrit(e)s à l'événement sélectionné ci-dessous. Dans l'événement actuel, le statut sera réglé sur 'Annulé'. Si souhaité, le type de prix peut être conservé - le prix sélectionné ne sera utilisé que s'il n'existe pas déjà dans l'événement choisi.",
    custom_field_select_edit_anyway: "Éditer la sélection de toute façon",
    unsaved_changes_dialog:
      "Vous avez apporté des modifications au formulaire. Voulez-vous vraiment fermer la boîte de dialogue?",
    close_dialog: "Voulez-vous vraiment fermer la boîte de dialogue?",
    delete_feedback_form:
      "Voulez-vous vraiment supprimer ce formulaire de rétroaction? Si des réponses existent déjà pour ce formulaire, elles seront également supprimées.",
    delete_question_group:
      "Voulez-vous vraiment supprimer ce groupe de questions? Toutes les questions au sein du groupe seront également supprimées du formulaire de rétroaction. Si des réponses existent déjà pour les questions contenues, elles seront également supprimées.",
    delete_question:
      "Voulez-vous vraiment supprimer cette question? Si des réponses existent déjà pour cette question, elles seront également supprimées.",
    delete_user:
      "Lorsque cette action est exécutée, toutes les données utilisateur seront définitivement supprimées. Les réservations, les factures associées et les e-mails envoyés sont exclus. Les acheteurs de commandes ouvertes ne peuvent être supprimés qu'une fois la commande annulée ou terminée.",
    delete_organization:
      "L'organisation, ses coordonnées, ses membres et ses champs personnalisés seront définitivement supprimés. Les organisations ayant des commandes ne peuvent pas être supprimées, archivez-les plutôt.",
    bulk_attendances_different_values: "Certaines réservations ont déjà des valeurs différentes pour la participation:",
    values_will_be_overwritten: "Ces valeurs seront écrasées. Voulez-vous continuer quand même?",
  },
  settings: {
    relative_commission_per_booking: {
      name: "Commission relative par réservation",
      description: "Ce facteur est utilisé pour calculer la commission relative par réservation.",
    },
    automated_data_deletion_active: {
      name: "Suppression automatique des enregistrements d'utilisateurs et de factures",
      description:
        "Activer la suppression automatique des enregistrements d'utilisateurs et de factures dans tout le système.",
    },
    automated_data_deletion_user_threshold_days: {
      name: "Seuil de suppression des utilisateurs en jours",
      description: "Après combien de jours les utilisateurs sont automatiquement supprimés.",
    },
    automated_data_deletion_invoice_threshold_days: {
      name: "Seuil de suppression des factures en jours",
      description: "Après combien de jours les factures sont automatiquement supprimées.",
    },
    relative_commission_eur_cap_per_booking: {
      name: "Commission relative maximale par réservation (€)",
      description: "Le montant maximum en euros pouvant être calculé comme commission relative par réservation.",
    },
    fix_commission_per_booking: {
      name: "Commission fixe par réservation (€)",
      description: "Ce montant est calculé en plus de la commission relative pour chaque réservation.",
    },
    fix_commission_per_month: {
      name: "Commission fixe par mois (€)",
      description: "Ce montant est calculé de façon fixe chaque mois.",
    },
    default_event_location: {
      name: "Lieu d'événement par défaut",
      description: "Ce lieu d'événement est présélectionné lors de la création d'événements.",
    },
    default_event_type: {
      name: "Type d'offre par défaut",
      description: "Ce type d'offre est présélectionné lors de la création d'offres.",
    },
    default_price_type: {
      name: "Type de prix par défaut",
      description: "Ce type de prix est présélectionné lors de la création de réservations.",
    },
    logo_path: {
      name: "URL du logo",
      description: "L'URL du logo souhaité dans la zone de connexion.",
    },
    login_text: {
      name: "Texte de connexion",
      description: "Texte d'info, affiché lors de la connexion.",
    },
    imprint_url: {
      name: "URL des mentions légales",
      description: "L'URL des mentions légales dans la zone de connexion.",
    },
    data_privacy_url: {
      name: "URL de la confidentialité des données",
      description: "L'URL de la confidentialité des données dans la zone de connexion.",
    },
    scopevisio_customer_id: {
      name: "ID client Scopevisio",
      description: "Le numéro de client Scopevisio",
    },
    scopevisio_refresh_token: {
      name: "Jeton de rafraîchissement Scopevisio",
      description: "Ce jeton est utilisé pour accéder à l'API Scopevisio",
    },
    scopevisio_webhook_secret: {
      name: "Secret webhook Scopevisio",
      description: "Attendu dans l'en-tête X-Scopevisio-Webhook-Secret",
    },
    stripe_api_key: {
      name: "API Key",
      description: "Der API Key, den Sie von stripe erhalten.",
    },
    stripe_cancel_redirect: {
      name: "Weiterleitung bei Fehler",
      description: "Die URL, zu der nach einem Abbruch des Checkouts, weitergeleitet wird.",
    },
    stripe_success_redirect: {
      name: "Weiterleitung bei Erfolg",
      description: "Die URL, zu der nach einem erfolgreichen Checkout weitergeleitet wird.",
    },
    stripe_invoice_name: {
      name: "Rechnungsname",
      description: "Der Bezeichner, der für die Rechungsdokumente verwendet wird.",
    },
    stripe_webhook_secret: {
      name: "Webhook secret",
      description: "Das Webhook secret von Stripe.",
    },
    moodle_api_token: {
      name: "Jeton API Moodle",
      description: "Ce jeton est utilisé pour accéder à l'API Moodle",
    },
    moodle_attendee_role_id: {
      name: "Rôle de participant",
      description: "Ce rôle est attribué aux participants lors de l'inscription",
    },
    moodle_host: {
      name: "Hôte Moodle",
      description: "Le nom de l'hôte du serveur où l'instance Moodle est hébergée",
    },
    moodle_lecturer_role_id: {
      name: "Rôle de formateur",
      description: "Ce rôle est attribué aux formateurs lors de l'inscription",
    },
    moodle_service: {
      name: "Service Web Moodle",
      description: "Le nom du service Web enregistré sur le serveur Moodle",
    },
    moodle_url: {
      name: "URL Moodle",
      description: "URL de l'instance Moodle (utilisée pour les liens)",
    },
    custom_theme: {
      name: "Thème personnalisé pour le portail EDM",
      description: "Thème Material UI pour le portail EDM (participants et formateurs).",
    },
    days_lecturers_may_change_attendance_after_event: {
      name: "Fin de modification pour la participation par les enseignants",
      description:
        "Combien de jours après la fin de l'événement les enseignants peuvent-ils encore modifier la participation",
    },
    is_portal_active: {
      name: "Portail EDM pour participants et enseignants",
      description: "Activer le portail EDM pour participants et enseignants",
    },
    website_url: {
      name: "Website URL",
      description: "L'URL de son propre site web. Celui-ci est par exemple lié dans le portail.",
    },
    lecturer_booking_export_active: {
      name: "Les enseignants peuvent exporter les écritures",
      description: "Faut-il afficher une fonction d'exportation des réservations sur le portail des enseignants?",
    },
    lecturer_emailing_active: {
      name: "Les professeurs peuvent envoyer des e-mails",
      description: "Faut-il afficher une fonction e-mail sur le portail des professeurs ?",
    },
    favicon_url: {
      name: "Favicon URL",
      description: "L'URL de la favicon souhaitée pour les pages publiques.",
    },
    read_emails_independent_of_sender: {
      name: "Les employés peuvent consulter tous les e-mails",
      description: "Les employés peuvent consulter les e-mails indépendamment de l'expéditeur",
    },
    public_portal_registration: {
      name: "Formulaire d'inscription public (portail)",
      description: "Le formulaire d'inscription au portail doit-il être accessible au public ?",
    },
    storefront_config: {
      name: "Configuration de la vitrine",
      description: "Paramètres pour la vitrine",
    },
    read_only: "Ce paramètre ne peut pas être modifié ici.",
    default_bcc: {
      name: "BCC par défaut",
      description: "Adresse e-mail ajoutée en CCI sur tous les e-mails sortants.",
    },
    frontend_event_base_path: {
      name: "Chemin de l'offre",
      description: "Modèle de chemin pour les pages d'offres. Paramètre : {slug}",
    },
    frontend_event_path_segment: {
      name: "Segment de chemin de l'événement",
      description: "Segment de chemin pour les événements individuels. Paramètre : {id}",
    },
    groups: {
      general: "Configuration générale",
      portal: "Portail",
      defaults: "Valeurs par défaut",
      storefront: "Site web",
      orders: "Commandes et factures",
    },
    order_validation_capacity: {
      name: "Imposer le contrôle de capacité",
      description:
        "Refuser les commandes/réservations qui dépasseraient le nombre maximal de participants d'un événement.",
    },
    order_validation_registration_window: {
      name: "Imposer la période d'inscription",
      description: "Refuser les commandes/réservations en dehors de la période d'inscription d'un événement.",
    },
    order_validation_event_started: {
      name: "Imposer le contrôle 'événement non commencé'",
      description: "Refuser les commandes/réservations pour des événements déjà commencés.",
    },
    order_validation_billing_address: {
      name: "Imposer le contrôle de l'adresse de facturation",
      description:
        "Refuser les commandes qui seront facturées lorsque l'acheteur n'a pas d'adresse de facturation utilisable.",
    },
    order_checkout_window_minutes: {
      name: "Fenêtre de paiement (minutes)",
      description: "Durée pendant laquelle une commande en attente réserve des places lors du paiement.",
    },
    order_manual_processing: {
      name: "Traitement manuel des commandes",
      description:
        "Si activé, les lignes de commande restent ouvertes jusqu'à ce que le personnel les traite en réservation. Si désactivé, les lignes sont réservées automatiquement après confirmation de la commande. Les types d'offre peuvent remplacer ce paramètre.",
    },
    order_unverified_user_retention_days: {
      name: "Conservation des personnes non vérifiées (jours)",
      description:
        "Après combien de jours les fiches de personnes non vérifiées auto-créées sont supprimées. Les personnes avec une réservation, une commande ouverte ou une ligne facturée sont toujours conservées. 0 = pas de suppression.",
    },
    invoice_payment_term_days: {
      name: "Délai de paiement (jours)",
      description:
        "Le nombre de jours après la date de facture à partir duquel une facture est due. La date d'échéance est enregistrée à la création de la facture et transmise à la comptabilité. 0 = aucune date d'échéance.",
    },
    invoice_auto_accounting_transfer: {
      name: "Transférer automatiquement les factures à la comptabilité",
      description:
        "Si activé, les factures nouvellement créées sont transférées automatiquement à la comptabilité. Les factures créées automatiquement - lorsque le traitement manuel des commandes est désactivé et après un paiement en ligne réussi - sont transférées indépendamment de ce paramètre.",
    },
    create_organization_with_account: {
      name: "Proposer la création d'une organisation à l'inscription",
      description: "Permettre aux utilisateurs de créer une organisation lors de la création d'un compte.",
    },
    cancellation_period: {
      name: "Délai d'annulation (jours)",
      description:
        "Nombre de jours après la création de la réservation pendant lesquels l'annulation est possible. 0 = aucune annulation possible.",
    },
    cancellation_contact_email: {
      name: "Email de contact pour les annulations",
      description: "Adresse e-mail recevant les notifications lors de l'annulation d'une réservation dans le portail.",
    },
    headlines: {
      emailing: "E-mails",
      links: "Liens",
      lecturers: "Intervenants",
      cancellation: "Annulation",
      data_deletion: "Suppression des données",
    },
  },
  sidebar: {
    admin_section: "Administration",
    accounting_section: "Ventes",
    users_section: "Personnes",
    imprint: "Mentions légales",
    data_privacy: "Confidentialité des données",
    info: "Info",
    administration: {
      main_data: "Données principales",
      user_management: "Accès",
      template_management: "Modèles",
      settings: "Paramètres",
    },
  },
  empty_state: "Aucun %{entity} disponible.",
  no_category: "Aucune catégorie",
  no_date: "Aucune date",
  no_event_base: "Aucune offre",
  no_value: "Aucune valeur",
  no_state: "Aucune région",
  oclock: "%{time} heures",
  all: "Tous",
  already_taken: "est déjà pris",
  born: "né(e) le %{date}",
  no_name: "Sans nom (#%{id})",
  "Bad Request": "Échec de la demande",
  Forbidden: "Pas d'autorisation pour cette action",
  "Not Found": "Enregistrement non trouvé",
  Unauthorized: "Non autorisé",
  "Internal Server Error": "Erreur interne du serveur",
  "NetworkError when attempting to fetch resource.": "Échec de la demande en raison d'une erreur réseau.",
  invalid_grant: "Les identifiants sont invalides",
  login_error: "Connexion momentanément impossible",
  login_error_message:
    "Malheureusement, une erreur est survenue lors de la communication avec le serveur. Veuillez réessayer ou contacter les administrateurs.",
  try_again: "Réessayer",
  enlarge: "Agrandir",
  shrink: "Réduire",
  notification: {
    login_created: "Connexion ajoutée |||| Connexions ajoutées",
    connect_success: "%{entity} lié avec succès",
    disconnect_success: "%{entity} déconnecté avec succès",
    disconnect_error: "Échec de la déconnexion de %{entity}",
    moodle: {
      connect_error: "Échec de la liaison de %{entity}",
      enrollment_success: "%{resource} inscrit avec succès",
      enrollment_error: "Échec de l'inscription de %{resource}",
      unenroll_success: "%{resource} désinscrit avec succès",
      unenroll_error: "Échec de la désinscription de %{resource}",
      suspend_success: "%{resource} mis en veille avec succès",
      suspend_error: "Échec de la mise en veille de %{resource}",
      unsuspend_success: "%{resource} défini avec succès sur actif",
      unsuspend_error: "Échec de la mise à jour de %{resource} sur Actif",
      create_error: "Impossible de créer %{entity}",
    },
    remove_from_group_error: "Échec de la suppression du groupe",
    remove_from_group_success: "Supprimé du groupe",
    upload_error: "Une erreur est survenue lors du téléchargement.",
    upload_error_reason: "Échec du téléchargement : %{reason}",
    unsupported_file_type: "Ce type de fichier n'est pas pris en charge. Types autorisés : %{types}.",
    upload_success: "Téléchargement réussi",
    check_for_password_reset: "Email pour réinitialiser le mot de passe envoyé",
    password_reset_error: "Adresse e-mail invalide ou inexistante",
    delete_error: "Erreur lors de la suppression de l'enregistrement",
    delete_price_enrollment_error:
      "Le prix ne peut pas être supprimé car %{entityCount} %{enrollment} non traités existent avec ce prix.",
    duplicate_todos_error: "Erreur lors de la duplication des tâches. L'événement a néanmoins été créé.",
  },
  archiving: {
    archive: "Archiver",
    archive_confirm: "Vraiment archiver %{resource}? |||| Archiver %{entityCount} %{resource}?",
    archive_success: "%{resource} archivé avec succès",
    archive_error: "Échec de l'archivage",
    events_affected: "Événements concernés : ",
    unarchive: "Restaurer",
    unarchive_confirm: "Vraiment restaurer %{resource}? |||| Restaurer %{entityCount} %{resource}?",
    unarchive_success: "%{resource} restauré avec succès",
    unarchive_error: "Échec de la restauration",
    valid_bookings_affected: "Réservations valides concernées : ",
  },
  editor: {
    hints: {
      bold: "Gras",
      italic: "Italique",
      heading1: "Titre 1",
      heading2: "Titre 2",
      heading3: "Titre 3",
      undo: "Annuler",
      redo: "Refaire",
      paragraph: "Paragraphe",
      list: "Liste",
      numberedList: "Liste numérotée",
      todoList: "Liste de tâches",
      link: "Lien",
    },
  },
  emailing: {
    attachments: "Pièces jointes",
    attendance_confirmation: "Envoyer la confirmation de participation",
    body: "Contenu",
    booking_confirmation: "Envoyer la confirmation de réservation",
    content_blocks: "Blocs de contenu",
    event_blocks: "Blocs d'événements",
    email_interested_users: "Contacter l'intéressé |||| Contacter les intéressés",
    feedback: "Envoyer le formulaire de feedback",
    invoice_kind: "Type de facture",
    invoice_not_found: "Une facture n'a pas pu être attribuée au destinataire et ne peut donc pas être envoyée.",
    no_body: "Le contenu de l'e-mail n'est actuellement pas disponible.",
    open_errors: "Erreurs non traitées",
    related_records: "Enregistrements associés",
    archive_job_hint: "Tous les e-mails de cet envoi sont également archivés.",
    unarchive_job_hint:
      "Tous les e-mails de cet envoi sont également restaurés, y compris ceux archivés individuellement.",
    no_template: "Aucun modèle sélectionné",
    no_receivers: "Aucun destinataire valide disponible",
    no_templates_for_scope: "Aucun modèle d'e-mail disponible pour ce domaine.",
    no_assigned_senders: "Vous n'avez encore attribué aucun expéditeur d'e-mail.",
    receivers: "Destinataires",
    send: "Envoyer",
    send_email: "Envoyer l'e-mail",
    recipients_label: "Destinataires :",
    sendtest: "Envoyer un test",
    signature: "Signature",
    subject: "Objet",
    sender: "Expéditeur",
    error: "Erreur lors de l'envoi de l'e-mail |||| Erreur lors de l'envoi des e-mails",
    sent_to_sib_at: "Transféré à Brevo à",
    success: "E-mail(s) envoyée(s) avec succès",
    template: "Modèle",
    test_error: "Erreur lors de l'envoi du test e-mail",
    test_success: "Test e-mail envoyé avec succès",
    testaddress: "Adresse e-mail de test",
    with_generated_document: "Le document généré sera automatiquement envoyé en pièce jointe.",
    upload_attachment: "Téléverser un document",
    generated_documents: "Documents générés",
    preview: "Aperçu",
    preview_error: "Erreur lors de la génération de l'aperçu: %{error}",
    scheduled_dispatch: "Envoi planifié",
    scheduled_send: "Envoyer l'e-mail(s)",
    day_before_event_start: "1 jour avant le début de l'événement",
    day_after_event_end: "1 jour après la fin de l'événement",
    scheduled_emails: "E-mail planifié |||| E-mails planifiés",
    waiting_list_confirmation: "Envoyer la confirmation pour la liste d'attente",
    contact_type: {
      invoice: "Adresses de facturation",
      communication: "Adresses de communication",
    },
    parties: {
      recipient: "Destinataire",
      attendee: "Participant*e",
      invoice_recipient: "Destinataire de la facture",
    },
    show_recipient_addresses:
      "Afficher l'adresse du destinataire |||| Afficher %{smart_count} adresses de destinataires",
    cc_info: "Un Cc est défini pour tous les e-mails (pas seulement pour un seul)",
    use_custom_email: "Indiquer une autre adresse e-mail",
    use_recipient_selection: "Utiliser la sélection de destinataires",
    total_file_size_exceeded_warning:
      "La taille maximale des e-mails est limitée à 20 Mo, pièces jointes et contenu compris. ",
  },
  merging: {
    error: "Échec de la fusion",
    merge_with: "Fusionner",
    person_to_merge: "Fusionner avec",
    success: "Fusion réussie",
    login_warning: "La personne sélectionnée possède une connexion.",
    info: {
      title: "Que se passe-t-il lors de la fusion ?",
      deletion_and_base_data:
        "La personne sélectionnée sera supprimée. Les données de base manquantes (titre, genre, date de naissance, etc.) seront complétées par celles de l'utilisateur à fusionner.",
      lecturer_and_attendee_data:
        "Les propriétés de participant et de formateur (y compris les champs personnalisés) sont entièrement reprises si l'utilisateur actuel ne possède pas ce rôle. Sinon, les valeurs manquantes sont ajoutées.",
      contact_info_and_login:
        "L'identifiant de connexion n'est repris que si la personne actuelle n'en possède pas. Les informations de contact doivent être transférées manuellement si nécessaire.",
      transferred_label: "Seront transférés :",
    },
  },
  invoice: {
    success: "Les factures ont été créées avec succès",
    error: "Erreur lors de la génération des factures",
    titles: {
      correction: "Correction de la facture [%{invoiceNumber}]",
      reversal: "Annulation de la facture [%{invoiceNumber}]",
      standard: "Facture",
    },
    correction_reversal: "Correction/Annulation",
    success_delete: "La facture a été supprimée avec succès",
    error_delete: "Erreur lors de la suppression de la facture",
    created_text:
      "Les factures suivantes ont été créées avec succès et peuvent être traitées avec les actions ci-dessous.",
    overview_text: "Les factures suivantes peuvent être traitées avec les actions ci-dessous.",
    send_to_accounting: "Transférer",
    selected_with_non_uniq_event: "Les factures sélectionnées doivent toutes appartenir au même événement",
  },
  show_detail_page: "Afficher la page de détail",
  export: {
    error: "Échec de l'exportation",
    actions: {
      export: "Exporter",
      resource: "Exporter %{resource}",
      event: "Événement",
      all_attendees: "Participants et réservations",
      all_lecturers: "Conférenciers",
    },
    fields: {
      days: "Jours",
      all_valid_bookings_count: "Nombre de participants",
    },
  },
  history: {
    action: {
      change: "modifié",
      create: "ajouté",
      delete: "supprimé",
      sent: "envoyé",
      sent_to: "envoyé à %{to}",
    },
    boolean_change: {
      is_bookable: {
        true: "rendu réservable",
        false: "rendu non réservable",
      },
      high_priority: {
        true: "épinglé",
        false: "détaché",
      },
      is_online: {
        true: "marqué comme événement en ligne",
        false: "marqué comme événement sur place",
      },
      is_public: {
        true: "publié",
        false: "non publié",
      },
    },
    special_change: "changé de %{oldValue} à %{newValue}",
    deleted: "supprimé",
    deleted_f: "supprimée",
    deleted_m: "supprimé",
    deleted_n: "supprimé",
    deleted_record: "Introuvable (enregistrement probablement supprimé) : %{id}",
    fetch_error: "Impossible de charger l'historique",
    field_change: "%{name}: %{oldValue} → %{newValue}",
    value_change: "%{oldValue} → %{newValue}",
    no_value: "Aucune valeur",
    archived: "Archivé",
    restored: "Restauré",
    show_all: "Afficher l'historique complet",
  },
  permission_actions: {
    create: "Ajouter",
    read: "Voir",
    update: "Modifier",
    delete: "Supprimer",
    update_debit_number: "Mettre à jour le numéro de débiteur",
  },
  feedback: {
    thank_you_headline: "Merci beaucoup",
    thank_you_description:
      "Nous tenons à vous remercier sincèrement d'avoir pris le temps de remplir notre formulaire de feedback.",
  },
  titles: {
    event_base_child_create: "Créer une offre pour %{name}",
    registration_date: "Période d'inscription",
    timespan: "Période",
  },
  actions: {
    remove_from_group: "Supprimer du groupe",
    remove_lecturer_from_event: "Supprimer de l'événement",
    reset_filters: "Réinitialiser les filtres",
    select_all: "Tout sélectionner",
    show_related_data: "Afficher les contenus liés",
    show_all: "Tout afficher",
    show_all_errors: "%{smart_count} erreur de plus |||| %{smart_count} erreurs de plus",
    show_less: "Afficher moins",
    send: "Envoyer",
    edit_dashboard: "Modifier le tableau de bord",
  },
  info_page: {
    software_version: "Version du logiciel",
    support: "Support",
    support_mail: "service@priorist.com",
    release_notes: "Notes de version",
    release_notes_link: "https://education-manager.de/releases",
    license: "Informations sur la licence",
    license_info:
      "EDM utilise des composants et bibliothèques tiers utiles. Nous remercions les auteurs de ces produits de les avoir mis à disposition du public. La section suivante contient les mentions légales requises pour les bibliothèques tierces incluses dans EDM :",
    is_licensed_under: "est licencié sous",
  },
  femCount: "Une %{entity} est |||| %{count} %{entity} sont",
  error: "Erreur",
  not: "Pas",
  by: "de",
  to: "à",
  at: "à",
  connected_with: "lié à",
  disconnect: "déconnecter",
  numbers: {
    2: "deux",
    3: "trois",
    4: "quatre",
    5: "cinq",
    6: "six",
    7: "sept",
    8: "huit",
    9: "neuf",
    decimalSeparator: ",",
    thousandSeparator: ".",
  },
  more: "plus",
  countMore: "%{count} plus",
  less: "moins",
  today: "Aujourd'hui",
  tomorrow: "Demain",
  no_data: "Pas de données disponibles",
  reports: {
    title: "Évaluation",
    sales: "Ventes",
    booking: "Réservation |||| Réservations",
    sold_item: "Place vendue |||| Places vendues",
    calendar_week_with_date: "SE %{kw} du %{date}",
    bookings_and_sales: "Places vendues et chiffre d'affaires",
    bookings_by_sales: "Prix de vente par chiffre d'affaires",
    cancellation_by_events: "Taux d'annulation événements",
    event_status_chart: "Événements par statut",
    report_by_base_data: "Données de base",
    total_occupancy: "Occupation totale",
    draft: "Brouillon",
    offered: "Offre",
    takes_place: "A lieu",
    finished: "Terminé",
    canceled: "Annulé",
    sales_with_amount: "EUR %{amount},- Chiffre d'affaires",
    best_offers: "Meilleures offres",
    anchor: "Date",
    anchor_order_date: "Date de commande",
    anchor_event_date: "Date de l'événement",
    date_from: "Du",
    date_to: "Au",
    event_format: "Format de l'événement",
    other: "Autres |||| Autres",
    states: "Évaluation par région",
    by_sales: "par chiffre d'affaires",
    by_bookings: "par places vendues",
    event_charts: "Évaluations",
    no_data_events: "Aucun événement pendant cette période",
    no_data_bookings: "Aucune réservation pendant cette période",
    no_data_event_bases: "Aucune offre réservée pendant cette période",
    metrics: {
      cancellation: "Annulation||||Annulations",
      events_carried_out: "Événement réalisé||||Événements réalisés",
      events_upcoming: "Événement à venir||||Événements à venir",
      average_price: "Prix moyen",
      wating_ratio: "Taux de liste d'attente",
    },
  },
  dashboard: {
    title: "Tableau de bord",
    no_data_bookings: "Aucune réservation disponible",
    bookings_overview: "Réservations actuelles",
    bookings_by_type: "Aperçu des participations",
    longest_waitinglist: "Liste d'attente la plus longue",
    registration_period_exceeded: "Période d'inscription atteinte",
    booked_out: "Complet",
    show_own: "Seulement les miennes",
    empty_timeline: "Aucune activité disponible",
    still_billable: "Encore à facturer",
    amount_open: "Ouvert",
    amount_total: "Montant total",
    few_bookings_necessary: "Seulement quelques réservations nécessaires",
    takes_place: "a lieu",
    upcoming_events: "Événements à venir",
    timespan: "Durée",
    in_room: "dans la salle %{room}",
    more_lecturers: "... %{count} de plus",
    less_lecturers: "... moins",
    valid: "Enregistré",
    waiting: "Liste d'attente",
    canceled: "Annulé",
    search_event: "Rechercher un événement",
    recent_edited: "Dernière modification",
    recent_orders: "Commandes récentes",
    filter: {
      today: "Aujourd'hui",
      yesterday: "Hier",
      next_seven_days: "Prochains 7 jours",
      next_thirty_days: "Prochains 30 jours",
      next_three_months: "Prochains 3 mois",
      last_seven_days: "7 derniers jours",
      last_thirty_days: "30 derniers jours",
      current_month: "Mois en cours",
      custom_range: "Période personnalisée",
      last_three_months: "3 derniers mois",
      last_six_months: "6 derniers mois",
      this_year: "Cette année",
      last_year: "L'année dernière",
      penultimate_year: "Avant-dernière année",
      remaining_year: "Reste de l'année",
    },
  },
  event_formats: {
    ONLINE: "En ligne",
    ONSITE: "Présentiel",
    HYBRID: "Hybride",
    E_LEARNING: "E-Learning",
  },
  attendance_formats: {
    ONLINE: "En ligne",
    ONSITE: "Présentiel",
    HYBRID: "Hybride",
  },
  email_scope_description: {
    NEW_MOODLE_ACCOUNT_TEMPLATE:
      "Utilisé automatiquement lorsqu'une personne est liée à un compte Moodle et qu'un nouveau compte Moodle est créé. Une seule modèle peut être assignée pour cet usage.",
    ENROLLMENT_APPROVAL_TEMPLATE:
      "Utilisé automatiquement lorsqu'une inscription doit être approuvée par une personne autorisée. Une seule modèle peut être assignée pour cet usage.",
    ENROLLMENT_DENIED_TEMPLATE:
      "Utilisé automatiquement lorsqu'une inscription est rejetée par une personne autorisée. Une seule modèle peut être assignée pour cet usage.",
    BOOKING_TEMPLATES: "Modèles utilisés dans le cadre des réservations.",
    BOOKING_CONFIRMATION_TEMPLATES:
      "Modèles pour confirmer une réservation réussie, par exemple lors du traitement des inscriptions.",
    LECTURER_TEMPLATES: "Modèles pour la communication avec les formateurs ou enseignants.",
    CONSENT_TEMPLATES:
      "Modèles utilisés pour les processus de consentement, comme lors d'un processus de double opt-in pour confirmer l'accès, par exemple au portail.",
    ENROLLMENT_CONFIRMATION_TEMPLATE:
      "Envoyé automatiquement après une inscription réussie (par exemple via le site web) à un événement. Une seule modèle peut être assignée pour cet usage.",
    FEEDBACK_TEMPLATES: "Modèles utilisés pour l'envoi de questionnaires de satisfaction.",
    NEW_ATTENDEE_TEMPLATE:
      "Utilisé automatiquement lorsqu'un identifiant est attribué à une personne ou à un formateur via l'interface EDM. Une seule modèle peut être assignée pour cet usage.",
    NEW_STAFF_MEMBER_TEMPLATE:
      "Utilisé automatiquement lorsqu'un identifiant est attribué à un membre du personnel via l'interface EDM. Une seule modèle peut être assignée pour cet usage.",
    ATTENDEE_TEMPLATES:
      "Modèles pour communiquer avec des personnes. Important : ces modèles ne sont pas disponibles dans le contexte des réservations, uniquement dans le contexte des personnes.",
    LECTURER_BOOKING_TEMPLATES:
      "Modèles disponibles dans le portail des formateurs, pour communiquer avec les participants.",
    INVOICE_TEMPLATES: "Modèles utilisés pour les factures.",
    PASSWORD_RESET_TEMPLATE:
      "Utilisé automatiquement pour envoyer un lien de réinitialisation de mot de passe. Une seule modèle peut être assignée pour cet usage.",
    ATTENDANCE_CONFIRMATION_TEMPLATES: "Modèles utilisés pour l'envoi des attestations de présence.",
    WAITING_LIST_TEMPLATES:
      "Modèles pour confirmer une réservation sur liste d'attente, par exemple lors du traitement des inscriptions.",
    ORDER_CONFIRMATION_TEMPLATE:
      "Envoyé automatiquement à l'acheteur lorsqu'une commande est confirmée. Un seul modèle peut être attribué à ce périmètre.",
    ORDER_ITEM_APPROVAL_TEMPLATE:
      "Envoyé automatiquement pour demander l'approbation externe d'une position de commande. Un seul modèle peut être attribué à ce périmètre.",
    ORDER_ITEM_DENIED_TEMPLATE:
      "Envoyé automatiquement lorsque l'approbation d'une position de commande est refusée. Un seul modèle peut être attribué à ce périmètre.",
    EVENT_LOCATION_TEMPLATES:
      "Modèles utilisables pour communiquer avec les lieux de l'événement. Les e-mails sont envoyés à l'adresse e-mail du lieu.",
  },
  permissions_description: {
    default:
      "Tableau de bord (sans Encore à facturer) / Voir les événements y compris les réservations / Voir les offres / Voir les participants / Voir les intéressés / Voir les enseignants / Exporter les enregistrements / Voir les notes / Voir l'historique",
    manage_events:
      "Créer, modifier et archiver des événements / Créer, modifier et supprimer des dates d'événements / Créer, modifier et supprimer des prix d'événements / Créer, modifier et supprimer des documents d'événements / Créer, modifier et supprimer des notes d'événements / Fonctions d'événements (p.ex. changer le statut, dupliquer, assigner un groupe, modifier l'offre)",
    manage_event_bases:
      "Créer, modifier et archiver des offres / Créer, modifier et supprimer des descriptions d'offres / Créer, modifier et supprimer des documents d'offres / Créer, modifier et supprimer des notes d'offres / Fonctions d'offres (p.ex. changer le type d'offre, dupliquer)",
    manage_orders:
      "Créer, confirmer, annuler et traiter les commandes / Réserver et attribuer les positions de commande / Créer les factures de commande / Envoi d'e-mails",
    manage_users:
      "Créer, modifier et archiver des personnes / Créer, modifier et supprimer les coordonnées / Créer, modifier et supprimer des étiquettes",
    manage_attendees:
      "Créer, modifier et archiver des participants / Créer, modifier et supprimer les coordonnées des participants / Créer, modifier et supprimer des documents des participants / Créer, modifier et supprimer des notes des participants / Fonctions des participants (p.ex. fusionner, créer un login) / Envoi d'e-mails",
    manage_interests: "Créer, modifier et supprimer les intéressés",
    manage_lecturers:
      "Créer, modifier et archiver des enseignants / Créer, modifier et supprimer les coordonnées des enseignants / Créer, modifier et supprimer des documents des enseignants / Créer, modifier et supprimer des notes des enseignants / Fonctions des enseignants (p.ex. fusionner, créer un login) / Envoi d'e-mails",
    manage_todos_and_responsibilities:
      "Créer, modifier et supprimer des tâches dans un événement / Créer, modifier et supprimer des responsabilités dans un événement",
    manage_moodle:
      "Lier, créer et supprimer des cours Moodle / Lier, créer et supprimer des comptes Moodle / Créer et supprimer des inscriptions Moodle",
    manage_bookings:
      "Créer, modifier et supprimer des réservations / Créer, modifier et supprimer des documents de réservation / Voir les factures / Envoi d'e-mails",
    manage_invoices:
      "Créer, modifier et supprimer des factures (y compris correction et annulation) / Envoyer des factures / Affichage de « encore à facturer » sur le tableau de bord",
    view_accounting: "Voir la comptabilité EDM",
    view_reporting: "Voir le rapport",
    view_booking_list: "Voir le menu de la liste des réservations",
    view_invoice_list: "Voir le menu de la liste des factures",
    manage_accounting:
      "Transférer des factures (par ex. à ScopeVisio) / Voir et modifier le numéro de débiteur des participants et les champs de compte des événements / Marquer les réservations comme payées",
    manage_access:
      "Créer, modifier et archiver des employés / Créer, modifier et supprimer des groupes d'autorisations / Créer, modifier et supprimer des applications OAuth",
    manage_templates:
      "Créer, modifier et supprimer des modèles d'e-mails / Créer, modifier et supprimer des expéditeurs d'e-mails / Créer, modifier et supprimer des modèles de documents / Créer, modifier et supprimer des responsabilités / Créer, modifier et supprimer des champs avancés / Créer, modifier et supprimer des listes de tâches",
    manage_settings:
      "Modifier les paramètres généraux / Créer, modifier et supprimer des types de prix / Créer, modifier et supprimer des environnements / Créer, modifier et supprimer des types d'offres / Activer et désactiver des applications liées",
    manage_base_data:
      "Créer, modifier et supprimer des lieux d'événements / Créer, modifier et supprimer des partenaires de coopération / Créer, modifier et supprimer des groupes cibles / Créer, modifier et supprimer des catégories / Créer, modifier et supprimer des mots-clés",
    manage_organizations: "Créer, modifier et supprimer des organisations. Ajouter des personnes aux organisations",
    manage_event_feedback:
      "Joindre un questionnaire de feedback pour l'événement / Voir l'évaluation du feedback spécifique à l'événement",
    view_feedback_report: "Voir l'évaluation générale du feedback",
  },
  portal: {
    welcome: "Bienvenue!",
    logged_in_as: "Vous êtes connecté en tant que",
    your_bookings: "Vos réservations",
    your_orders: "Vos commandes",
    your_interests: "Vos favoris personnels",
    your_events: "Vos événements",
    your_organizations: "Vos organisations",
    show_past_bookings: "Réservations passées",
    show_past_events: "Événements passés",
    event_canceled: "Cet événement a été annulé",
    booking_waitinglist: "Vous êtes sur la liste d'attente",
    booking_canceled: "Cette réservation a été annulée",
    missing_consent:
      "Veuillez noter que vous n'avez pas encore confirmé votre adresse e-mail. Seule une fois la confirmation effectuée, l'utilisation des fonctions du portail est possible. Si vous n'avez pas reçu d'e-mail de vérification ou si vous en avez besoin d'un autre, veuillez utiliser le bouton ci-dessous.",
    confirm_your_email: "Veuillez confirmer votre adresse e-mail",
    resend_verification_mail: "Renvoyer l'e-mail de confirmation",
  },
  languages: {
    de: "Allemand",
    en: "Anglais",
    fr: "Français",
    es: "Espagnol",
  },
  admin: {
    descriptions: {
      event_locations: "Gérer les sites et les salles",
      partners: "Enregistrer les données des partenaires avec descriptions",
      audiences: "Définir les groupes cibles pour les offres",
      categories: "Structurer et gérer les catégories thématiques",
      tags: "Créer des tags pour la recherche et les filtres",
      user_lists: "Gérer et maintenir des listes de personnes et de contacts",

      staff_members: "Administrer les comptes et gérer les droits",
      user_roles: "Définir et attribuer les autorisations",
      o_auth_apps: "Enregistrer des applications externes et gérer les jetons",
      subscriptions: "Gérer les webhooks pour différents événements",

      email_senders: "Configurer les profils d'expéditeur et les signatures",
      external_email_templates: "Créer et versionner les courriels standards",
      custom_field_content_types: "Modéliser des attributs personnalisés",
      responsibility_types: "Définir des responsables par type d'offre",
      todo_lists: "Créer des listes de tâches et définir des modèles",
      document_templates: "Téléverser des modèles Office, définir des champs de substitution",
      invoice_templates: "Configurer le design avec facture électronique incluse",
      feedback_forms: "Concevoir et gérer des questionnaires",

      settings: "Adapter les paramètres globaux et l'identité visuelle",
      event_types: "Définir les types avec champs de description",
      customer_invoices: "Consulter la facturation d'utilisation d'Education Manager",
      customer: "Configurer les données organisationnelles et les contacts",
      price_types: "Gérer les variantes de prix et les réductions",
      contexts: "Délimiter vos offres pédagogiques",
      tax_rates: "Gérer les taux de TVA",
      integrated_applications: "Voir les intégrations",
      consent_types: "Gérer les catégories de consentement selon le RGPD",
      settings_general: "Configurer les paramètres généraux, liens et e-mails",
      settings_portal: "Configurer le portail participants et l'accès formateurs",
      settings_defaults: "Définir les valeurs par défaut pour les nouvelles formations",
      settings_storefront: "Personnaliser la configuration du storefront",
      settings_orders: "Configurer les validations de commande, le comportement du paiement et la facturation",
    },
  },
  mdx: {
    dialogControls: {
      save: "Enregistrer",
      cancel: "Annuler",
    },
    createLink: {
      url: "URL",
      urlPlaceholder: "Sélectionner ou coller une URL",
      title: "Titre",
      saveTooltip: "Définir l'URL",
      cancelTooltip: "Annuler les modifications",
    },
    linkPreview: {
      open: "Ouvrir {{url}} dans une nouvelle fenêtre",
      edit: "Modifier l'URL du lien",
      copyToClipboard: "Copier dans le presse-papiers",
      copied: "Copié !",
      remove: "Supprimer le lien",
    },
    toolbar: {
      blockTypes: {
        paragraph: "Paragraphe",
        quote: "Citation",
        heading: "Titre {{level}}",
      },
      blockTypeSelect: {
        selectBlockTypeTooltip: "Sélectionner un type de bloc",
        placeholder: "Type de bloc",
      },
      toggleGroup: "Groupe à bascule",
      removeBold: "Retirer le gras",
      bold: "Gras",
      removeItalic: "Retirer l'italique",
      italic: "Italique",
      underline: "Souligné",
      removeUnderline: "Retirer le soulignement",
      removeInlineCode: "Retirer le format code",
      inlineCode: "Code en ligne",
      link: "Créer un lien",
      richText: "Texte enrichi",
      diffMode: "Mode de comparaison",
      source: "Mode source",
      admonition: "Insérer une admonition",
      codeBlock: "Insérer un bloc de code",
      editFrontmatter: "Modifier les métadonnées",
      insertFrontmatter: "Insérer les métadonnées",
      image: "Insérer une image",
      insertSandpack: "Insérer un Sandpack",
      table: "Insérer un tableau",
      thematicBreak: "Insérer une séparation thématique",
      bulletedList: "Liste à puces",
      numberedList: "Liste numérotée",
      checkList: "Liste de tâches",
      deleteSandpack: "Supprimer ce bloc de code",
      undo: "Annuler {{shortcut}}",
      redo: "Rétablir {{shortcut}}",
      highlight: "Surligner",
      removeHighlight: "Supprimer le surlignage",
    },
    contentArea: {
      editableMarkdown: "Markdown modifiable",
    },
    parseError: "Échec de l'analyse du contenu markdown. Le contenu peut contenir un formatage invalide.",
  },
  event_date_planner: {
    series_toggle: "Ajouter une série de dates",
    time_toggle: "Spécifier l'heure",
    details_toggle: "Détails supplémentaires",
    no_existing_dates: "Aucune date disponible",
    existing_dates: "Afficher la date |||| Afficher %{smart_count} dates",
    add_dates: "Ajouter des dates",
    save_planned_dates: "Enregistrer",
    remove_all_dates: "Supprimer toutes les dates",
    planned_dates: "Ajouter %{smart_count} date |||| Ajouter %{smart_count} dates",
    every: "tous les",
    weeks: "semaine(s)",
    months: "mois",
    days: "jour(s)",
    years: "année(s)",
    weekly: "Hebdomadaire",
    monthly: "Mensuel",
    daily: "Quotidien",
    on: "Jusqu'au",
    after: "Après x fois",
    single_date: "Dates individuelles",
    rrule: {
      name: "Dates récurrentes",
      interval: "Intervalle",
      start: "Début",
      frequency: "Fréquence",
      end_condition: "Se termine",
      end_date: "Date de fin",
      end_count: "Répétitions",
    },
    weekdays: {
      monday: "Lun",
      tuesday: "Mar",
      wednesday: "Mer",
      thursday: "Jeu",
      friday: "Ven",
      saturday: "Sam",
      sunday: "Dim",
    },
  },
};

export default frenchMessages;
